<template>
  <base-layout>
    <div class="add-timesheets">
      <ob-layout :type="11">
        <template slot="title">
          <div style="display:none;"><input type="text"><input type="password"></div>
          <span @click="TimesheetCancel()" style="color: rgb(49, 151, 235);  cursor: pointer;">{{ timesheetLabel }}</span><span> <i
              style="font-size: 22px;margin: 0px 5px 15px;" class="fa fa-angle-right"></i></span>{{timesheetId == '' ? `Add ${timesheetLabel}/Expenses` : `Update ${timesheetLabel}/Expenses`}}</template>
        <template slot="body">
          <div class="add_timesheets-body">
            <div class="row">
              <div class="col-md-12">
                <label style="color:#464444">Please choose an option to submit.</label>
                <div class="row rowgap">
                  <div class="col-md-3">
                    <div class="form-group">
                      <div class="radio-inline">
                        <ob-radio name="TimesheetType" val="TimesheetOnly" v-model="TimesheetType"
                          :disabled="isTimesheetDisabled">
                          <span style="font-weight:600;font-size: 14px;">{{ timesheetLabel }} only</span>
                        </ob-radio>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <div class="radio-inline">
                        <ob-radio name="TimesheetType" val="ExpensesOnly" v-model="TimesheetType"
                          :disabled="isExpensesDisabled" @change.native="OnselectedTimesheetType('ExpensesOnly')">
                          <span style="font-weight:600;font-size: 14px;">Expenses only</span>
                        </ob-radio>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <div class="radio-inline" style="padding-left: 0;">
                        <ob-radio name="TimesheetType" val="TimesheetAndExpenses" v-model="TimesheetType"
                          :disabled="isTimesheetExpensesDisabled"
                          @change.native="OnselectedTimesheetType('TimesheetAndExpenses')">
                          <span style="font-weight:600;font-size: 14px;">{{ timesheetLabel }} & Expenses</span>
                        </ob-radio>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="$route.query.from == 'employer-timesheets'">
              <div class="form-group row">
                <div class="col-md-12">
                  <h5 style="font-weight:600">Please provide the employee details.</h5>
                </div>
              </div>
              <div class="form-group col-md-12 pL0" style="border-top: white 2px solid;">
                <div class="col-md-12 pL0">
                  <div class="col-md-4 pL0 pR0">
                    <label style="color:#464444">Select Candidate</label><span class="validation-star">*</span>
                    <ob-select2 v-if="showEmployeeList" :options="candidateListOptions" v-model="employeeSelected"
                      ref="employeeListRef" :class="{ 'ob-vuelidate_input-error': $v.employeeSelected.$error }">
                    </ob-select2>
                    <span class="ob-vuelidate_error-msg"
                      v-if="$v.employeeSelected.$dirty && !$v.employeeSelected.requiredIf">Select Candidate</span>
                    <ob-checkbox style="margin-top: 6px;" :val="1" v-model="checkedC2C">Show only C2C/1099 employees</ob-checkbox>
                  </div>
                  <div class="col-md-4" v-if="selectedEmployeeID != null && selectedEmployeeID != ''">
                    <label style="color:#464444">Select Project</label><span class="validation-star">*</span>
                    <span style="">
                      <ob-select2 v-if="showProjectOptions" :options="projectListOptions" v-model="projectSelected"
                        :class="{ 'ob-vuelidate_input-error': $v.projectSelected.$error }"></ob-select2>
                      <span class="ob-vuelidate_error-msg"
                        v-if="$v.projectSelected.$dirty && !$v.projectSelected.requiredIf">Please choose a project to proceed further</span>
                      <ob-checkbox style="margin-top: 6px;" :type="1" v-model="isChecked">Show Completed Projects only</ob-checkbox></span>
                  </div>
                  <div class="col-md-4" v-if="selectedEmployeeID != null && selectedEmployeeID != ''">
                    <label style="color:#464444">Select Range</label><span class="validation-star">*</span>
                    <div class="row">
                      <div class="col-md-6 pR0">
                        <ob-date-time-picker ref="dateFrom" :key="Count" id="dateFrom" :options="DatePickerOptions"
                          :inputvalue="dateFrom" @updated="(v) => this.dateFrom = v" :dpchange="onFromDateChange"
                          v-model.trim="dateFrom" :disabled="isDateRangeDisable"
                          :class="{ 'ob-vuelidate_input-error': $v.dateFrom.$error && !isDateRangeDisable }"></ob-date-time-picker>
                        <span class="ob-vuelidate_error-msg" v-if="$v.dateFrom.$dirty && !$v.dateFrom.required && !isDateRangeDisable">Select From Date</span>
                      </div>
                      <div class="col-md-6 pR0">
                        <ob-date-time-picker ref="dateTo" id="dateTo" :key="keyValueUpdate" :options="options4"
                          :inputvalue="dateTo" @updated="(v) => this.dateTo = v" v-model.trim="dateTo"
                          :disabled="isDateRangeDisable" :class="{ 'ob-vuelidate_input-error': $v.dateTo.$error && !isDateRangeDisable }">
                        </ob-date-time-picker>
                        <span class="ob-vuelidate_error-msg" v-if="$v.dateTo.$dirty && !$v.dateTo.required && !isDateRangeDisable">Select To Date</span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-md-5 pR0" style="margin-top: 10px;">
                  <div class="col-md-6 pR0 pL0">
                    <div class="col-md-3 m0 p0">
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_total-hours.svg`" style="margin-right: 10px;width: 40px;"/>
                    </div>
                    <div class="col-md-9 mL0 pR0" style="line-height: 20px;padding-left: 6px;">
                      <ob-input @blur="sendHours()"  v-number-only  @keyup.enter.native="sendHours()"  v-model="directHoursEntered" style="width: 80%" v-if="isHoursEntered"></ob-input>
                      <label  @mouseover="onHrsClick()" v-else style="color:#464444 ; font-weight: 600;font-size: 16px;cursor:pointer"> {{DetailMode ? TotalHoursWorked : QuickModeTotalHours}}</label>
                      <p style="font-weight: 500;">Total Hours Worked</p>

                    </div>
                  </div>
                  <div class="col-md-6 pL0 pR0">
                    <div class="col-md-3 m0 p0">
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_expense.svg`" style="margin-right: 10px;width: 40px;"/>
                    </div>
                    <div class="col-md-9 mL0 pR0 " style="line-height: 20px;padding-left: 6px;">
                      <label style="color:#464444 ; font-weight: 600;font-size: 16px"> ${{Number((totalExpensesAmount).toFixed(2))}}</label>
                      <p style="font-weight: 500;">Total Expense(s)</p>
                    </div>
                  </div>
                </div> -->
                <span class="ob-vuelidate_error-msg" v-if="isDateRangeDisable">You cannot add a {{ timesheetLabel.toLowerCase() }} for this employee as their employment start date is either not available or in the future.</span>
              </div>
            </div>
            <div v-else>
              <div class="form-group row" v-if="projectList != null && projectList != ''">
                <div class="col-md-12">
                  <h5 style="font-weight:600">Please select the project and corresponding date range.</h5>
                </div>
              </div>
              <div class="form-group row" v-else>
                <div class="col-md-12">
                  <h5 style="font-weight:600">Please select the date range.</h5>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 pL0">
                  <div class="col-md-11 pL0">
                    <div class="col-md-6 pR0">
                      <label style="color:#464444">Select Project</label><span class="validation-star">*</span>
                      <span></span><span style="position:absolute;right:5px;margin-top:-4px;"><ob-checkbox :type="1"
                          v-model="isChecked">Show Completed Projects only</ob-checkbox></span>
                      <ob-select2 v-if="showProjectOptions" :options="projectListOptions" v-model="projectSelected"
                        :class="{ 'ob-vuelidate_input-error': $v.projectSelected.$error }"></ob-select2>
                      <span class="ob-vuelidate_error-msg"
                        v-if="$v.projectSelected.$dirty && !$v.projectSelected.requiredIf">Please choose a project to proceed further</span>
                    </div>
                    <div class="col-md-6">
                      <label style="color:#464444">Select Range</label><span class="validation-star">*</span>
                      <div class="row">
                        <div class="col-md-6 pR0">
                          <ob-date-time-picker ref="dateFrom" :key="Count" id="dateFrom" :options="DatePickerOptions"
                            :inputvalue="dateFrom" @updated="(v) => this.dateFrom = v" :dpchange="onFromDateChange"
                            v-model.trim="dateFrom" :disabled="isDateRangeDisable"
                            :class="{ 'ob-vuelidate_input-error': $v.dateFrom.$error && !isDateRangeDisable }"></ob-date-time-picker>
                          <span class="ob-vuelidate_error-msg" v-if="$v.dateFrom.$dirty && !$v.dateFrom.required && !isDateRangeDisable">Select From Date</span>
                        </div>
                        <div class="col-md-6 pR0">
                          <ob-date-time-picker ref="dateTo" id="dateTo" :key="keyValueUpdate" :options="options4"
                            :inputvalue="dateTo" @updated="(v) => this.dateTo = v" v-model.trim="dateTo" :disabled="isDateRangeDisable"
                            :class="{ 'ob-vuelidate_input-error': $v.dateTo.$error && !isDateRangeDisable }"></ob-date-time-picker>
                          <span class="ob-vuelidate_error-msg" v-if="$v.dateTo.$dirty && !$v.dateTo.required && !isDateRangeDisable">Select To Date</span>
                        </div>
                      </div>
                    </div>
                      <span class="ob-vuelidate_error-msg" style="margin-left: 16px;" v-if="isDateRangeDisable">You cannot add a {{ timesheetLabel.toLowerCase() }} as your employment start date is either not available or in the future.</span>
                  </div>
                  <!-- <div class="col-md-5 pR0" style="margin-top: 10px;">
                    <div class="col-md-6 pR0 pL0">
                      <div class="col-md-3 m0 p0">
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_total-hours.svg`" style="margin-right: 10px;width: 40px;"/>
                      </div>
                      <div  class="col-md-9 mL0 pR0" style="line-height: 20px;padding-left: 6px;">
                        <ob-input  @blur="sendHours()" v-number-only @keyup.enter.native="sendHours()"  v-model="directHoursEntered" style="width: 80%"  v-if="isHoursEntered"></ob-input>
                        <label  @mouseover="onHrsClick()" v-else style="color:#464444 ; font-weight: 600;font-size: 16px;cursor:pointer"> {{DetailMode ? TotalHoursWorked : QuickModeTotalHours}}</label>
                        <p style="font-weight: 500;">Total Hours Worked</p>
                      </div>
                    </div>
                    <div class="col-md-6 pL0 pR0">
                      <div class="col-md-3 m0 p0">
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_expense.svg`" style="margin-right: 10px;width: 40px;"/>
                      </div>
                      <div class="col-md-9 mL0 pR0 " style="line-height: 20px;padding-left: 6px;">
                        <label style="color:#464444 ; font-weight: 600;font-size: 16px"> ${{Number((totalExpensesAmount).toFixed(2))}}</label>
                        <p style="font-weight: 500;">Total Expense(s)</p>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="col-md-12 m0 p0"
              v-if="projectSelected != null && projectSelected != '' && projectSelected != undefined && projectSelected != 'Project unavailable' && TimesheetType != 'ExpensesOnly'">
              <div class="col-md-12" style="background: #E5F4FF;padding: 15px;margin: 10px 0;">
                <div class="col-md-12 pL0">
                  <ul class="headerStrip" style="list-style-type: disc;padding-left: 15px;margin: 0">
                    <li>
                      <span style="font-weight:600;padding-left:0px;font-size: 12px;">Your employer defined a <b>{{ getTimeSheetCycleName(timesheetCycle) }}</b> {{ timesheetLabel }} cycle for the project <b>{{ projectName }}</b>. However you can change the dates and enter the {{ timesheetLabel.toLowerCase() }} below.</span>
                    </li>
                    <li v-if="isTaskMandatory">You must add tasks as per your employer settings.</li>
                    <li v-if="timesheetAttachments">You must add client approval {{ timesheetLabel.toLowerCase() }} as per your employer settings.</li>
                    <li v-if="!IsAllowFutureDate">Your employer has disabled adding future dated {{ timesheetLabel.toLowerCase() }}.</li>
                    <li
                      v-if="MaximumRegulerTimesheetHours != undefined && MaximumRegulerTimesheetHours != null && MaximumRegulerTimesheetHours != 0">Your employer has set the maximum regular time hour limit to <b>{{ MaximumRegulerTimesheetHours }}</b> per day.
                    </li>
                    <li v-if="!AllowTimeSheetSubmissionOnHolidays"> Your employer has disallowed {{ timesheetLabel.toLowerCase() }} submissions on Federal holidays.</li>
                    <li v-if="!AllowTimeSheetSubmissionOnLeaves">Your employer has disallowed {{ timesheetLabel.toLowerCase() }} submissions on Leaves.</li>
                  </ul>

                </div>
              </div>
            </div>
            <!-- <div v-if="IsCoincide" class="row pL0" style="margin-bottom:10px;margin-top:10px;">
              <div class="col-md-12"><img :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info-icon-orange.svg`' style="width:18px;border-radius:50%;margin-right:6px;">
                <span style="color:#F07431">This {{ timesheetLabel.toLowerCase() }} range coincides with an existing {{ timesheetLabel.toLowerCase() }} {{coinsideDateFrom}} to {{coinsideDateTo}}. However, you can edit the existing one.</span>
              </div>
            </div> -->
            <div class="row"
              v-if="timesheetAttachments && projectSelected != null && projectSelected != '' && projectSelected != undefined">
              <div class="col-md-12">
                <!-- <h5 style="font-weight:600;margin: 0;padding-top: 14px;">Please upload Client approved Timesheets.</h5> -->
              </div>
            </div>
            <div class="attachments_view" v-if="TimesheetType != 'ExpensesOnly'">
              <template v-for="(item, index) in Attachments">
                <div class="attachments-view" style="margin-top: 10px;">
                  <template>
                    <span id="task-title">{{ getFileName(item) }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference" style="cursor:pointer;display:inline-block;margin-left:10px" />
                    </ob-popover>
                  </template>
                  <span style="margin-top: -25px; padding-top: 2px;padding-bottom: 6px;margin-left: 0px">
                    <span class="cross-mark" @click="removeAttachments(index)"
                      style="font-size: 11px; padding: 2px 5px;">&#10006;</span>
                  </span>
                </div>
              </template>
              <div v-if="showAttachmentDiv">
                <ob-upload-attachment ref="upload" :key="iCounter" @error-msg="IsInvalidFile"
                  @file-inProgress="InProgress" @file-complete="onuploadComplete" :validation="ValidationType"
                  :end-point="EndPoint" :type="1" :IsFileExists="filename" :attach-file.sync="attachFile">
                  <template slot="file-text">
                    <i class="fa fa-cloud-upload" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Drag and Drop &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Choose File
                  </template>
                </ob-upload-attachment>
              </div>
              <div class="row" style="border-bottom: 1.5px dashed #d4cccc;">
                <div class="col-md-12 pL0" style="margin-bottom: 8px;padding-left:16px;padding-top: 10px;">
                  <a @click="onAddAtachment()">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" style="margin-right: 5px;" />
                    <span style="color:#464444;font-weight: 600;">Add Client approved {{ timesheetLabel }}</span>
                  </a>
                </div>
                <div class="col-md-12 pL0" style="margin-bottom:10px;">
                  <span style="font-style: italic;color: #9f9f9f;">We accept either pdf, doc, docx, zip, xls, xlsx, images upto 25MB.</span>
                  <span class="validation-star" v-if="timesheetAttachments">*</span>
                </div>
                <div class="col-md-12 pL0"
                  v-if="timesheetAttachments && projectSelected != null && projectSelected != '' && projectSelected != undefined"
                  style="margin-bottom: 10px;">
                  <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="isErrorMessageDisabled">{{ errorMessageFrmResponse }}</span>
                  <span class="ob-vuelidate_error-msg" v-else-if="isValidate">Please upload Client approved {{ timesheetLabel }}</span>
                </div>
                <div class="col-md-12 pL0" style="margin-bottom: 10px;" v-else>
                  <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="isErrorMessageDisabled">{{ errorMessageFrmResponse }}</span>
                </div>
              </div>
            </div>
          </div>
          <template v-if="WorkSheets.length > 0 && TimesheetType != 'ExpensesOnly'">
            <div class="col-md-12 p0" style="margin-top: 15px;">
              <div class="col-md-7 pL0">
                <!-- <span class="toggle-span" style="background:#F3F5F7;margin-top: 6px">
                  <button v-if="!isTaskMandatory" class="toggle-btn "
                    :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'"
                    @click="onQuickClick">QUICK</button>
                  <button v-else :disabled="isTaskMandatory" class="toggle-btn "
                    :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onQuickClick">
                    <span
                      v-tooltip="`Your employer has mandated the submission of tasks along with the ${timesheetLabel.toLowerCase()}.`">QUICK</span>
                  </button>
                  <button class="toggle-btn" :class="DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'"
                    @click="onDetailClick">DETAIL</button>
                </span> -->

                <!-- <span v-if="projectSelected !== 'Project unavailable'" class="toggle-span" style="background:#F3F5F7;margin-top: 6px">
                  <button v-if="!isTaskMandatory && !IsHybridMode" class="toggle-btn "
                    :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'"
                    @click="onQuickClick">QUICK</button>
                  <button v-else :disabled="isTaskMandatory" class="toggle-btn "
                    :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onQuickClick">
                    <span
                      v-tooltip="`Your employer has mandated the submission of tasks along with the ${timesheetLabel.toLowerCase()}.`">QUICK</span>
                  </button>
                  <button v-if="isTaskMandatory && !IsHybridMode" class="toggle-btn" :class="DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onDetailClick">DETAIL</button>
                  <button v-else :disabled="!isTaskMandatory" class="toggle-btn" :class="DetailMode ? 'btn-toggle-selected':'btn-toggle-un-selected'" @click="onDetailClick">DETAIL</button>
                </span>
                 <span v-else class="toggle-span" style="background:#F3F5F7;margin-top: 6px">
                  <button  class="toggle-btn "
                    :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onQuickClick">
                    QUICK
                  </button>
                  <button class="toggle-btn" :class="DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'"
                    @click="onDetailClick">DETAIL</button>
                </span> -->
                  <span  class="toggle-span" style="background:#F3F5F7;margin-top: 6px"> <!--v-if="projectSelected !== 'Project unavailable'"--->
                    <button v-if="!IsQuickOrDetailMode && !IsHybridMode" class="toggle-btn "
                      :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'"
                      @click="onQuickClick">QUICK</button>
                    <button v-else-if="IsQuickOrDetailMode && !IsHybridMode" :disabled="IsQuickOrDetailMode" class="toggle-btn "
                      :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onQuickClick">
                      <span
                        v-tooltip="`Your employer has mandated the submission of tasks along with the ${timesheetLabel.toLowerCase()}.`">QUICK</span></button>

                    <button v-else class="toggle-btn " :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onQuickClick">QUICK</button>
                        
                    <button v-if="IsQuickOrDetailMode && !IsHybridMode" class="toggle-btn" :class="DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onDetailClick">DETAIL</button>
                    <button v-else-if="!IsQuickOrDetailMode&& !IsHybridMode" :disabled="!IsQuickOrDetailMode" class="toggle-btn" :class="DetailMode ? 'btn-toggle-selected':'btn-toggle-un-selected'" @click="onDetailClick">DETAIL</button>
                    <button v-else class="toggle-btn" :class="DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'"
                    @click="onDetailClick">DETAIL</button>
               </span>
                 <!-- <span v-else class="toggle-span" style="background:#F3F5F7;margin-top: 6px">
                    <button v-if="!isTaskMandatory && !IsHybridMode" class="toggle-btn "
                    :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'"
                    @click="onQuickClick">QUICK</button>
                   <button v-else-if="isTaskMandatory && !IsHybridMode" :disabled="isTaskMandatory" class="toggle-btn "
                      :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onQuickClick">
                      <span
                        v-tooltip="`Your employer has mandated the submission of tasks along with the ${timesheetLabel.toLowerCase()}.`">QUICK</span></button>

                    <button v-else class="toggle-btn " :class="!DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onQuickClick">QUICK</button>

                  <button v-if="isTaskMandatory && !IsHybridMode" class="toggle-btn" :class="DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onDetailClick">DETAIL</button>
                  <button v-else-if="!isTaskMandatory && !IsHybridMode" :disabled="!isTaskMandatory" class="toggle-btn" :class="DetailMode ? 'btn-toggle-selected':'btn-toggle-un-selected'" @click="onDetailClick">DETAIL</button>
                    <button v-else class="toggle-btn" :class="DetailMode ? 'btn-toggle-selected' : 'btn-toggle-un-selected'" @click="onDetailClick">DETAIL</button>
                </span> -->
              </div>
              <div class="col-md-5 pR0" v-if="TimesheetType == 'TimesheetOnly'">
                <div class="col-md-5 pR0 pL0"></div>
                <div class="col-md-7 pL0 pR0">
                  <div class="col-md-3 m0 p0">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_total-hours.svg`" style="margin-right: 10px;width: 40px;" />
                  </div>
                  <div class="col-md-9 mL0 pR0" style="line-height: 20px;padding-left: 6px;">

                    <template v-if="DetailMode">
                      <label style="color:#464444 ; font-weight: 600;font-size: 16px">{{ DetailMode? TotalHoursWorked: QuickModeTotalHours }}</label>
                    </template>

                    <template v-else>
                      <a style="text-decoration: underline;font-size: 13px;font-weight: 700;"
                        v-if="QuickModeTotalHours == '0h 0m'" @click="openTimeDistributionPopup()">Enter Total Time</a>
                      <label v-else style="color:#464444 ; font-weight: 600;font-size: 16px">
                        {{ DetailMode? TotalHoursWorked: QuickModeTotalHours }}
                        <span @click="openTimeDistributionPopup('EDIT')"
                          style="background: rgb(49, 151, 235); border-radius: 4px; display: inline-block; padding: 1px 4px; margin-left: 10px; cursor: pointer; float: right; color: white;">
                          <i class="fa fa-pencil" style="font-size: 14px;"></i>
                        </span>
                      </label>
                    </template>
                    <!-- <ob-input  @blur="sendHours()" v-number-only @keyup.enter.native="sendHours()"  v-model="directHoursEntered" style="width: 80%" v-if="isHoursEntered"></ob-input>
                    <label @mouseover="onHrsClick()" v-else style="color:#464444 ; font-weight: 600;font-size: 16px;cursor:pointer"> {{DetailMode ? TotalHoursWorked : QuickModeTotalHours}}</label>

                    <label style="color:#464444 ; font-weight: 600;font-size: 16px"> {{DetailMode ? TotalHoursWorked : QuickModeTotalHours}}</label> -->
                    <p class="total-hours" style="font-weight: 500;">Total Hours Worked</p>
                  </div>
                </div>
              </div>
              <div class="col-md-5 pR0" v-else-if="TimesheetType == 'TimesheetAndExpenses'">
                <div class="col-md-6 pR0 pL0">
                  <div class="col-md-3 m0 p0">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_total-hours.svg`" style="margin-right: 10px;width: 40px;" />
                  </div>
                  <div class="col-md-9 mL0 pR0" style="line-height: 20px;padding-left: 6px;">

                    <template v-if="DetailMode">
                      <label style="color:#464444 ; font-weight: 600;font-size: 16px">{{ DetailMode? TotalHoursWorked: QuickModeTotalHours }}</label>
                    </template>

                    <template v-else>
                      <a style="text-decoration: underline;font-size: 13px;font-weight: 700;"
                        v-if="QuickModeTotalHours == '0h 0m'" @click="openTimeDistributionPopup()">Enter Total Time</a>
                      <label v-else style="color:#464444 ; font-weight: 600;font-size: 16px">
                        {{ DetailMode? TotalHoursWorked: QuickModeTotalHours }}

                        <span @click="openTimeDistributionPopup('EDIT')"
                          style="background: rgb(49, 151, 235); border-radius: 4px; display: inline-block; padding: 1px 4px; margin-left: 10px; cursor: pointer; float: right; color: white;">
                          <i class="fa fa-pencil" style="font-size: 14px;"></i>
                        </span>
                      </label>
                    </template>
                    <!-- <ob-input  @blur="sendHours()" v-number-only @keyup.enter.native="sendHours()"  v-model="directHoursEntered" style="width: 80%" v-if="isHoursEntered"></ob-input>
                    <label @mouseover="onHrsClick()" v-else style="color:#464444 ; font-weight: 600;font-size: 16px;cursor:pointer"> {{DetailMode ? TotalHoursWorked : QuickModeTotalHours}}</label>

                    <label style="color:#464444 ; font-weight: 600;font-size: 16px"> {{DetailMode ? TotalHoursWorked : QuickModeTotalHours}}</label> -->
                    <p class="total-hours" style="font-weight: 500;">Total Hours Worked</p>
                  </div>
                </div>
                <div class="col-md-6 pL0 pR0">
                  <div class="col-md-3 m0 p0">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_expense.svg`" style="margin-right: 10px;width: 40px;" />
                  </div>
                  <div class="col-md-9 mL0 pR0 " style="line-height: 20px;padding-left: 6px;">
                    <label style="color:#464444 ; font-weight: 600;font-size: 16px">
                      ${{ Number((totalExpensesAmount).toFixed(2))}}</label> <p style="font-weight: 500;">Total Expense(s)</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <h5 style="font-weight:600;margin-top: 14px;line-height: 1.5;">'Detail Mode' includes both tasks and work performed in the selected date range, while 'Quick' mode includes only the number of hours. Please choose the mode based on your preference.</h5>
            </div>


            <template v-if="DetailMode">
              <div class="daterange" v-for="(item, index) in WorkSheets">
                <template :id="index">
                  <div class="row" v-if="!item.IsWeekDay || (!AllowTimeSheetSubmissionOnHolidays && (item.DayType == 'FederalHoliday' || item.DayType == 'Holiday')) || (!AllowTimeSheetSubmissionOnLeaves && (item.DayType == 'Leave'))">
                    <div class="col-md-12">
                      <div class="col-md-10 disabled-day">
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_calendar.svg`" style="margin-right: 10px;" /><span
                          style="color:#333333;margin-right: 5px;">{{ getDayFormat(item.Date) }}</span>
                        <span style="color:#8595A6">{{ getDateFormat(item.Date) }}</span>
                        <span v-if="item.DayType === 'Leave'" class="leave-tag" style="color: #CF355F;">(On Leave)</span>
                      </div>
                      <div class="col-md-2 disabled-day">
                        <span style="margin-right: 10px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_total_hrs.svg`"
                            style="margin-left: 6px;margin-right: 10px;" />{{ WorkSheets[index].totalTime }}</span>
                        <i data-v-e4c5d918="" aria-hidden="true" class="fa fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>

                  <ob-collapse :type="7" :expand="true" theme="default" v-else>
                    <template slot="collapse-title">
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_calendar.svg`" style="margin-right: 10px;" /><span
                        style="color:#333333;margin-right: 5px;">{{ getDayFormat(item.Date) }}</span>
                      <span style="color:#8595A6">{{ getDateFormat(item.Date) }}</span>
                      <span v-if="item.DayType === 'Leave'" class="leave-tag" style="color: #CF355F;">(On Leave)</span>
                    </template>
                    <template slot="collapse-title-right">
                      <span style="margin-right: 10px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_total_hrs.svg`"
                          style="margin-right: 10px;" />{{ WorkSheets[index].totalTime }}</span>
                    </template>
                    <template slot="collapse-details">
                      <div>
                        <div class="col-md-12" style="padding:0 0 10px">
                          <span style="color:#F07431">{{ holidayTypeDisplay(item) }}</span>
                        </div>
                        <div class="form-group row" style="border-bottom: 1.5px dashed #d4cccc;">
                          <!-- <div class="col-md-3">
                            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_project-title.svg`" style="margin-right: 10px;"/><label style="color:#464444">Project Name</label>
                          </div>-->
                          <div class="col-md-7" style="margin-right: 8px;">
                            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_task-title.svg`" style="margin-right: 10px;" /><label
                              style="color:#464444">Task Title</label><span v-if="isTaskMandatory"
                              class="validation-star">*</span>
                            <!-- <div style="display: inline-block;float: right;">
                              <a @click="openAddTask()" v-if="showAddTaskButton(WorkSheets[index].totalTime)">
                                <img style="margin-right: 4px;width: 17px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`"/>
                                <span style="color:#464444">
                                  Add Task
                                </span>
                              </a>
                            </div>-->
                          </div>
                          <div class="col-md-2 p0" style="margin-bottom: 10px;">
                            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_duration.svg`" style="margin-right: 10px;" /><label
                              style="color:#464444">Regular Time</label><span class="validation-star">*</span>
                          </div>
                          <div class="col-md-2 p0" style="margin-bottom: 10px;" v-if="IsOverTimeApplicable">
                            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_duration.svg`" style="margin-right: 10px;" /><label
                              style="color:#464444">Over Time</label>
                          </div>
                        </div>
                        <div class="row">
                          <div v-for="(task, Index) in item.tasksList" :key="Index">
                            <div class="form-group row">
                              <div class="col-md-12 pR0">
                                <div style="display:none;">{{ task.Date = item.Date }}</div>
                                <div class="col-md-7" style="z-index: 0 !important;">
                                  <ob-select2 v-if="showTaskSelect2" :options="taskOptions" v-model="task.TaskId"
                                    :class="{ 'ob-vuelidate_input-error': $v.WorkSheets.$each[index].tasksList.$each[Index].TaskId.$error }"
                                    :change="updateTaskList(task.TaskId, index, Index)"></ob-select2>
                                  <span v-if="$v.WorkSheets.$each[index].tasksList.$each[Index].TaskId.$error"
                                    class="ob-vuelidate_error-msg">Select task title</span>
                                </div>

                                <div class="col-md-2 p0" style="z-index: 0 !important;">
                                  <ob-input class="select2_style" :maxLength="2" v-number-only placeholder="hrs"
                                    v-model="task.Hours" :change="select2close(index, Index, 'RTH', task.Hours)"
                                    :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(WorkSheets[index], task.Hours) || $v.WorkSheets.$each[index].tasksList.$each[Index].Hours.$error || compareMaxHours(WorkSheets[index], task.Hours) }"></ob-input>
                                  <ob-input class="select2_style" :maxLength="2" v-number-only placeholder="mins"
                                    v-model="task.Minutes" :change="select2close(index, Index, 'RTM', task.Minutes)"
                                    :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(WorkSheets[index], task.Minutes) || $v.WorkSheets.$each[index].tasksList.$each[Index].Minutes.$error || compareMaxHours(WorkSheets[index], task.Minutes) }"></ob-input>
                                </div>
                                <div class="col-md-2 p0" style="z-index: 0 !important;" v-if="IsOverTimeApplicable">
                                  <ob-input class="select2_style" :maxLength="2" v-number-only placeholder="hrs"
                                    v-model="task.OverTimeHours"
                                    :change="select2close(index, Index, 'OTH', task.OverTimeHours)"
                                    :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(WorkSheets[index], task.OverTimeHours) || $v.WorkSheets.$each[index].tasksList.$each[Index].OverTimeHours.$error }"></ob-input>
                                  <ob-input class="select2_style" :maxLength="2" v-number-only placeholder="mins"
                                    v-model="task.OverTimeMinutes"
                                    :change="select2close(index, Index, 'OTM', task.OverTimeMinutes)"
                                    :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(WorkSheets[index], task.OverTimeMinutes) || $v.WorkSheets.$each[index].tasksList.$each[Index].OverTimeMinutes.$error }"></ob-input>
                                </div>
                                <div class="col-md-1 pL0" style="z-index: 0 !important;margin-top:4px;">
                                  <span @click="removeTask(index, Index)" v-if="Index >= 0">
                                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_remove.svg`"
                                      style="cursor:pointer;display:inline-block;" />
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="col-md-7" style="padding-right: 7px;"  v-if="task.TaskId != null && task.TaskId != ''">
                                  <textarea placeholder="Enter Task Details" v-if="!task.IsTaskDisabled" :disabled="task.IsTaskDisabled" :class="'descriptn'" :maxLength="500" v-model.trim="task.TaskDescription" @input="IsDescEdited(task.TaskId, task.TaskDescription, Index, index)"></textarea>
                                  <textarea v-tooltip = "'You do not have permission to edit this task. Please contact your employer'" v-else placeholder="Enter Task Details" :disabled="task.IsTaskDisabled" :class="'disable_textArea'" :maxLength="500" v-model.trim="task.TaskDescription"></textarea>
                                </div>
                              </div>
                              <!-- <a v-if="task.TaskId != null && task.TaskId != ''" style="font-size: 13px;font-weight: 400;margin-left: 30px;color: #2196F3" @click="editTask(task)">View/Edit task details</a> -->

                            </div>
                          </div>

                          <div class="form-group row" style="margin-left: 2px;margin-bottom:0px;">
                            <div class="col-md-12 add_task">
                              <div v-if="compareMaxHours(WorkSheets[index], 9)" style="padding-bottom:5px;">
                                <span v-if="IsPreviousRTHoursExist(WorkSheets[index])" class="ob-vuelidate_error-msg">As there are previously added {{ timesheetLabel.toLowerCase() }}(s) for this day, the total regular time exceeds {{ MaximumRegulerTimesheetHours }} hours. Please verify</span>
                                <span v-else class="ob-vuelidate_error-msg">Please enter valid hours. Your employer has set the maximum regular time hour limit to {{ MaximumRegulerTimesheetHours }} hours per day.</span>
                              </div>
                              <div v-else-if="totalHoursvalidation(WorkSheets[index], 9)">
                                <span class="ob-vuelidate_error-msg">The total work time cannot be more than 24 hours per day.</span>
                              </div>
                              <a @click="addTaskDetails(item.tasksList, item.date, index)"
                                v-if="showAddTaskButton(WorkSheets[index].totalTime, index)">
                                <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" />
                                <span style="color:#464444;font-weight: 600;">{{(item.tasksList).length != 0 ? "Add More" : "Add"}}</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>                     
                    </template>
                  </ob-collapse>
                </template>
              </div>
            </template>
             <!-- Planned Activities for Detail Mode -->
                        <div class="row" v-if="DetailMode" style="padding: 1%;margin-bottom: 20px;">
                          <div class="col-md-12">
                            <div class="form-group" style="margin-top: 20px;margin-bottom: -22px;">
                              <label>Planned activities for the next period</label>
                              <span v-if="isTaskMandatory" class="validation-star">*</span>
                              <ob-textarea
                                v-model.trim="plannedActivities"
                                placeholder="Type Here" :class="{ 'ob-vuelidate_input-error': $v.plannedActivities.$error }"/>
                              <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if=" $v.plannedActivities.$dirty && $v.plannedActivities.$error "> Please Enter Planned activities</span>
                            </div>
                          </div>
                        </div>
            <template v-else>
              <quick-mode-timesheets @totalHoursWorked="totalHoursWorkedQuickMode" ref="quicktimesheets"
                :WorkSheets.sync="QuickModeWorkSheets" :IsOverTimeApplicable="IsOverTimeApplicable"
                :PreviousWorkHours.sync="PreviousWorkHours"
                :AllowTimeSheetSubmissionOnHolidays.sync="AllowTimeSheetSubmissionOnHolidays"
                :AllowTimeSheetSubmissionOnLeaves.sync = "AllowTimeSheetSubmissionOnLeaves"
                :MaximumRegulerTimesheetHours.sync="MaximumRegulerTimesheetHours"></quick-mode-timesheets>
            </template>
             <!-- Quick Mode Activities Fields -->
          <div class="row" v-if="!DetailMode" style="padding:1%">
            <div class="col-md-12">
          <div class="form-group" style="padding-top: 10px;" >
            <label>Current Period Activities</label>
            <span v-if="isTaskMandatory" class="validation-star">*</span>
            <ob-textarea
              v-model.trim="currentPeriodActivities"
              placeholder="Type Here" :class="{ 'ob-vuelidate_input-error': $v.currentPeriodActivities.$error }"/>
            <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="$v.currentPeriodActivities.$dirty && $v.currentPeriodActivities.$error"> Please Enter Current Period Activities</span>
          </div>
          <div class="form-group">
            <label>Planned activities for the next period</label>
            <span v-if="isTaskMandatory" class="validation-star">*</span>
            <ob-textarea
              v-model.trim="plannedActivities"
              placeholder="Type Here"  :class="{ 'ob-vuelidate_input-error': $v.plannedActivities.$error }"/>
            <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="$v.plannedActivities.$dirty && $v.plannedActivities.$error"> Please Enter Planned activities</span>
          </div>
        </div>
          </div>
          </template>
          <div class="row"
            v-if="projectSelected != null && projectSelected != '' && projectSelected != undefined && TimesheetType != 'ExpensesOnly'"
            style="padding:1%">
            <div class="col-md-12">
              <div class="form-group">
                <label>Comments</label>
                <span class="validation-star" v-if="IsDCAAComplianceToggleOn">*</span>
                <ob-textarea :class="{ 'ob-vuelidate_input-error': !isCommentsValid }" :maxLength="150"
                  v-model.trim="Comments" placeholder="Enter Comments">
                </ob-textarea>
                <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="!isCommentsValid">Please Enter Comments</span>
              </div>
            </div>
          </div>
          <timeSheet-expenses ref="timesheetExpenses"
            :isExpenseErrorMessageDisabled.sync="isExpenseErrorMessageDisabled" @expensesAmount="expensesAmount"
            v-if="WorkSheets.length > 0" @isValidExpenses="isValidExpenses" :TimeSheetdateFrom.sync="dateFrom"
            :TimeSheetdateTo.sync="dateTo" :ExpenseModel.sync="ExpenseModel" :TimesheetType="TimesheetType"
            @expenseModelUpdate="updateparent"></timeSheet-expenses>
          <evaluation-popup :TimeSheetdateFrom.sync="dateFrom" :TimeSheetdateTo.sync="dateTo"
            :openEvalutionPopup.sync="openEvalutionPopup" :TimesheetType="TimesheetType"></evaluation-popup>
          <evaluation-rating :ApprovedTimeSheetId="TimesheetId" :selectedEmployee="employeeSelected"
            :EvaluationStatus="'Pending'" :TimeSheetdateFrom.sync="dateFrom" :TimeSheetdateTo.sync="dateTo"
            :openModal.sync="openEvaluationRating"></evaluation-rating>
          <evaluation-report :iframeURL="iframeURL" :EvaluationStatus="'Pending'"
            :openModal.sync="openEvaluationReport"></evaluation-report>
        </template>
        <template slot="footer">
          <div v-if="$route.query.from == 'employer-timesheets'">
            <ob-button type="secondary" @click="cancel()">Cancel</ob-button>
            <ob-button :disabled="TimesheetProjectList.length == 0" @click="isValid('submit')">Submit and approve</ob-button>
            <ob-button type="secondary" @click="isValid('Add')" :disabled="TimesheetProjectList.length == 0"
              v-tooltip="{ content: tooltipContent }">Save</ob-button>
          </div>
          <div v-else>
            <ob-button type="secondary" @click="cancel()">Cancel</ob-button>
            <ob-button :disabled="!IsValidHours" @click="isValid('Add')">Send for Approval</ob-button>
            <ob-button :disabled="!IsValidHours" v-if="timesheetId == null || timesheetId == ''"
              @click="isValid('Save')">Save</ob-button>
            <ob-button :disabled="!IsValidHours"
              v-else-if="TimesheetType == 'TimesheetOnly' && timeSheetDetails.TimeSheetStatus == 'Saved'"
              @click="isValid('Save')">Save</ob-button>
            <ob-button :disabled="!IsValidHours" v-else-if="TimesheetType == 'ExpensesOnly' && ExpenseStatus == 'Saved'"
              @click="isValid('Save')">Save</ob-button>
            <ob-button :disabled="!IsValidHours"
              v-else-if="TimesheetType == 'TimesheetAndExpenses' && (timeSheetDetails.TimeSheetStatus == 'Saved' && (ExpenseStatus == 'Saved' || ExpenseStatus == ''))"
              @click="isValid('Save')">Save</ob-button>
          </div>
        </template>
      </ob-layout>
      <div class="Expense_popOver" ref="expensePopoverWrapper" v-if="showHoursEnterPopover && !OkGotIt">
        <div class="row" style="color:white">
          <div style="padding: 7px 0 0 24px;" class="col-md-12">
            <label>Time Entry !</label><br>
            <p style="color:white;font-size:11px;max-width:90%">Now you can enter duration for the whole selected period so that it will distribute accross the selected days.</p>
            <ob-button class="btn_gotit" type="secondary" @click="OnGotItClick()">GOT IT</ob-button>
          </div>

        </div>
      </div>

      <add-task :openModal.sync="openAddTaskPopup" :IsEdit ="isEdit" :PreviousData.sync ="previousData" @HandleAfterTaskUpdate="HandleAfterTaskUpdate"></add-task>

      <ob-modal2 :show.sync="showTimeDistributionPopup" :type="1" :backdrop="false">
        <div style="color: #143361;padding: 21px 15px;font-size: 16px;font-weight: 700;">Enter Total Time</div>
        <div class="col-md-12"> <strong>Total time will be distributed to selected date range <b>({{ getDateFormat(dateFrom) }} - {{ getDateFormat(dateTo) }}) </b> equally. However you can manually adjust based on your requirement</strong> </div>
        <div style="padding:60px 15px;">
          <div class="col-md-6 p0" style="z-index: 0 !important;">

            <label style="color:#464444;display:block">Total Regular Time <span class="validation-star">*</span>
            </label>

            <ob-input style="width:120px" class="select2_style" v-number-only placeholder="Enter Hours"
              v-model="RegularDistributionHours"
              :class="{ 'ob-vuelidate_input-error': (CheckRegularDistributionHours && RegularDistributionHours > 0) || $v.RegularDistributionHours.$error }"></ob-input>
            <ob-input style="width:120px" :maxLength="2" class="select2_style" v-number-only placeholder="Enter Minutes"
              v-model="RegularDistributionMinutes"
              :class="{ 'ob-vuelidate_input-error': (CheckRegularDistributionHours && RegularDistributionMinutes > 0) || $v.RegularDistributionMinutes.$error }"></ob-input>
          </div>
          <div class="col-md-6 p0" style="z-index: 0 !important;" v-if="IsOverTimeApplicable">

            <label style="color:#464444;display:block"> Total Over Time </label>

            <ob-input style="width:120px" class="select2_style" v-number-only placeholder="Enter Hours"
              v-model="OverTimeDistributionHours"></ob-input>
            <ob-input style="width:120px" :maxLength="2" class="select2_style" v-number-only placeholder="Enter Minutes"
              v-model="OverTimeDistributionMinutes"
              :class="{ 'ob-vuelidate_input-error': $v.OverTimeDistributionMinutes.$error }"></ob-input>
          </div>
        </div>
        <div style="padding:10px 15px;" v-if="(CheckRegularDistributionHours)">
          <span v-if="PreviousWorkHours.length > 0" class="ob-vuelidate_error-msg">As there are previously added {{ timesheetLabel.toLowerCase() }}(s) for certain days, entered work distribution hours are exeeding the {{ MaximumRegulerTimesheetHours }} hours per day. Please verify</span>
          <span v-else class="ob-vuelidate_error-msg">Entered work distribution hours are exeeding the {{ MaximumRegulerTimesheetHours }} hours per day. Please enter valid hours. Your maximum regular work hour limit is {{ MaximumRegulerTimesheetHours }} hours per day.</span>
        </div>
        <div>
          <ob-checkbox :disabled="true"
            v-if="this.$refs.quicktimesheets != undefined && this.$refs.quicktimesheets != null && this.$refs.quicktimesheets.weekendsList != null && this.$refs.quicktimesheets.weekendsList != ''"
            style="padding: 5px 30px 5px;" :type="1" v-model="showTimeDistributionPopup">Exclude {{ this.$refs.quicktimesheets.weekendsList }} from distribution</ob-checkbox>
          <ob-checkbox v-else style="padding: 5px 30px 5px;margin-bottom:10px" :type="1"
            v-model="IsWeekendChecked">Exclude Saturday and Sunday from distribution</ob-checkbox>


          <div class="col-md-12">
            <div class="col-md-12"
              style="background: rgb(74,144,226,0.1);padding: 15px;margin: 0px 0px 30px 0px;color: rgb(74,144,226);font-size: 12px;border-radius: 5px;"
              v-if="this.$refs.quicktimesheets != undefined && this.$refs.quicktimesheets != null && this.$refs.quicktimesheets.weekendsList != null && this.$refs.quicktimesheets.weekendsList != ''">
              <div class="col-md-1 pL0" style="padding-right: 0;width:3%;">
                <img :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_bulb_line.svg`' style="width:12px;border-radius:50%;">
              </div>
              <div class="col-md-11 pL0">
                <span style="font-weight:600;padding-left:0px;font-size: 12px;"> As per your employer, you cannot add {{ timesheetLabel.toLowerCase() }} for <span> {{ this.$refs.quicktimesheets.weekendsList }} </span> . Please reach out to your employer to enable this option.</span>
              </div>
            </div>
          </div>
        </div>
        <div style="padding: 0px 20px 20px 20px;text-align:center;">
          <ob-button style="width: 120px;" type="secondary" @click="OnDistributionPopupCancel()">Cancel</ob-button>
          <ob-button style="width: 120px;" @click="OnDistributionHoursEnter()">Distribute</ob-button>
        </div>
      </ob-modal2>

    </div>
  </base-layout>
</template>
<script>
import c from 'Vue/Core/constants.js'
import utils from "Vue/Core/utils.js";
import CommonFunctionMixin from '../Timesheets/CommonFunctionMixin'
import AddTask from  "@/components/ESSProfile/Tasks/AddTask.vue";
import TimeSheetExpenses from './TimeSheetExpenses';
import QuickModeTimesheets from './QuickModeTimesheets.vue';
import EvaluationPopup from './Calender/ApprovalFlow/EvaluationPopup';
import EvaluationRating from './EvaluationReport'
import EvaluationReport from './ApprovalReport'
import jquery from "jquery";
import { createPopper } from '@popperjs/core';
import { required, minLength, maxLength, requiredIf, email, alpha, minValue, maxValue } from 'vuelidate/lib/validators';
export default {
  props: ["selectedReport"],
  mixins: [CommonFunctionMixin],
  data() {
    return {
      TimeSheetStatus : '',
      project: '',
      isSavedClicked: false,
      Comments: '',
      PreviousWorkHours: [],
      OkGotIt: false,
      IsWeekendChecked: false,
      RegularDistributionHours: '',
      RegularDistributionMinutes: '',
      OverTimeDistributionHours: '',
      OverTimeDistributionMinutes: '',
      showTimeDistributionPopup: false,
      IsSunday: false,
      IsMonday: true,
      IsTuesday: true,
      IsWednesday: true,
      IsThursday: true,
      IsFriday: true,
      IsSaturday: false,
      IsAllowFutureDate: false,
      AllowTimeSheetSubmissionOnHolidays: false,
      AllowTimeSheetSubmissionOnLeaves:false,

      directHoursEntered: "",
      showHoursEnterPopover: false,
      showPopover: true,
      isHoursEntered: false,
      isTaskMandatory: false,
      iCounter: '',
      isErrorMessageDisabled: false,
      errorMessageFrmResponse: '',
      PreviousDate: '',
      //selectedEmpName:'',
      openEvaluationRating: false,
      openEvalutionPopup: false,
      iframeURL: '',
      openEvaluationReport: false,
      TimesheetId: "",
      keyValueUpdate: 0,
      candidatesOptionList: [],
      checkedC2C: false,
      selectedEmployeeID: '',
      isChecked: false,
      showProjectOptions: true,
      TimesheetProjectList: [],
      ExpenseModel: [],
      QuickModeTotalHours: 0,
      QuickModeWorkSheets: [],
      DetailMode: true,
      projectList: '',
      employeeSelected: '',
      projectSelected: '',
      timesheetCycle: '',
      MaximumRegulerTimesheetHours: 0,
      timesheetAttachments: '',
      IsOverTimeApplicable: false,
      showTaskSelect2: true,
      IsWorkingDaysAvailable: false,
      coinsideDateFrom: '',
      coinsideDateTo: '',
      timesheetId: '',
      timeSheetDetails: [],
      Hours: '',
      Minute: '',
      WorkSheets: [],
      workingDaysList: [],
      totalTime: '',
      showAttachmentDiv: false,
      showProjectTitle: false,
      ProjectTitleList: '',
      taskTitleList: '',
      dateArray: [],
      dateFrom: '',
      dateTo: '',
      tasksList: [{
        ProjectId: '',
        TaskId: '',
        Date: '',
        Hours: '',
        Minutes: '',
      }],
      totalExpensesAmount: 0,
      isExpensesValid: false,
      options4: {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        // maxDate: moment().add(1, 'months'),
        maxDate: false,
        widgetPositioning: {
          horizontal: 'right',
          vertical: 'bottom'
        }
      },
      showEmployeeList: true,
      EmpList: [],
      employeeList: [],
      projectOptions: {
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
        ]
      },
      // projectListOptions:{
      //   placeholder: {
      //     id: "-1",
      //     text: "Select"
      //   },
      //   data: [
      //   ],
      // },
      taskOptions: {
        data: [],
        placeholder: {
          id: '-1',
          text: 'Please select '
        },
        tags: true,
        insertTag: function (data, tag) {
          if (tag.text === '') {
            tag = null
          }
          if (data.length < 1 || data == undefined) {
            tag = {
              id: tag.text,
              text: tag.text,
              newTag: true
            }
            data.push(tag);
          }
        },
        templateResult: function (data) {
          var result = '';
          if (data.newTag != true) {
            result += '<p style="padding-bottom:0px"></p><div><p style="font-size:12px;color:#143361;font-weight:550;padding-bottom:0px">' + data.text + '</p></div>'
          }
          else {
            result += '<div class="select"><div style="float:left;padding-right:2px"><div><img style="height:30px;width:30px;background-color: white;border-radius:50%;" :src="' + c.CDNIMAGESBASEURL + '/ess/ESSApp/static/Images/ic_add.svg"></div></div><div></div>'
            result += '<div style="display:inline-block"><div style="overflow: hidden:"><p style="font-size:12px;color:#143361;font-weight:550;overflow-x:hiddenmargin-bottom: 0px;;">' + data.text + '</p><span style="font-size:9px;">Will be added to Tasks</span></div></div></div>'
            data.newTag = false;
          }
          return jquery(result);
        }
      },
      isValidate: false,
      docUrl: '',
      Attachments: [],
      ValidationType: {
        Rules: {
          Type: ["pdf", "zip", "xls", "xlsx", "doc", "docx", "png", "jpng", "gif", "jpg", "jpeg"],
          Size: 26000000,
          multiplefiles: true
        },
        Messages: {
          Type: "Please upload valid file formats",
          Size: `Please upload a file which is less than 25MB`,
        },
        excludeList: false
      },
      filename: [],
      EndPoint: `${c.APIBASEURL}/File/FileUpload`,
      attachFile: false,
      TimesheetType: 'TimesheetOnly',
      isTimesheetDisabled: false,
      TimesheetOrExpense: '',
      ExpenseId: '',
      ExpenseStatus: '',
      Count: 0,
      ProjectEndDate: '',
      tooltipContent: `You can save the ${this.timesheetLabel}(s) now and approve later.`,
      isExpenseErrorMessageDisabled: "",
      IsDCAAComplianceToggleOn: false,
      submissionPreferenceType: '',

      openAddTaskPopup: false,
      isEdit:false,
      previousData:[],
      employmentStartDate: '',
      currentPeriodActivities: '',
      plannedActivities: '',
      IsHybridMode : false,
      IsQuickOrDetailMode : false,

    }
  },
  validations() {
    return {
      RegularDistributionHours: {
        requiredIf: requiredIf((d) => {
          if (this.RegularDistributionMinutes != null && this.RegularDistributionMinutes != '') {
            return false
          } else {
            return true
          }
        }),
        minValue: minValue(0)
      },
      RegularDistributionMinutes: {
        requiredIf: requiredIf((d) => {
          if (this.RegularDistributionHours != null && this.RegularDistributionHours != '') {
            return false
          } else {
            return true
          }
        }),
        minValue: minValue(0),
        maxValue: maxValue(59)
      },
      OverTimeDistributionMinutes: {
        minValue: minValue(0),
        maxValue: maxValue(59)
      },
      "dateFrom": {
        required
      },
      "dateTo": {
        required
      },
      "currentPeriodActivities": {
        required
      },
      "plannedActivities": {
        required
      },
      "employeeSelected": {
        requiredIf: requiredIf((a) => {
          if (this.$route.query.from == 'employer-timesheets') {
            return true
          } else {
            return false
          }
        })
      },
      "projectSelected": {
        requiredIf: requiredIf((a) => {
          if (this.projectList != '' && this.projectList != null) {
            return true
          } else {
            return false
          }
        })
      },
      WorkSheets: {
        $each: {
          'tasksList': {
            $each: {
              "Hours": {
                requiredIf: requiredIf((d) => {
                  if (d.Minutes != null && d.Minutes != '') {
                    return false
                  } else {
                    return true
                  }
                }),
                minValue: minValue(0),
                maxValue: maxValue(24)
              },
              "Minutes": {
                requiredIf: requiredIf((d) => {
                  if (d.Hours != null && d.Hours != '') {
                    return false
                  } else {
                    return true
                  }
                }),
                minValue: minValue(0),
                maxValue: maxValue(59)
              },
              "TaskId": {
                requiredIf: requiredIf((d) => {
                  if ((d.TaskId != '' && !this.isTaskMandatory) || (d.TaskId != null && !this.isTaskMandatory)) {
                    return false
                  } else {
                    return true
                  }
                }),
              },
              "OverTimeHours": {
                minValue: minValue(0),
                maxValue: maxValue(24)
              },
              "OverTimeMinutes": {
                minValue: minValue(0),
                maxValue: maxValue(59)
              }
            }
          }
        }
      }
    }
  },
  components: {
    //   "add-task":AddTask,
    "timeSheet-expenses": TimeSheetExpenses,
    "quick-mode-timesheets": QuickModeTimesheets,
    "evaluation-popup": EvaluationPopup,
    "evaluation-rating": EvaluationRating,
    "evaluation-report": EvaluationReport,
    "add-task" : AddTask,
  },
  watch: {
    openModal(val) {
      this.show = val;
    },
    show(val) {
      this.$emit('update:openModal', val)
    },
    isChecked(val) {
      this.showProjectOptions = false
      this.getProjectOptionList()
    },
    checkedC2C(val) {
      this.showEmployeeList = false
      this.getCandidatesOptionList()
    },
    dateFrom(val) {
      if (val != null && this.dateTo != null && val != '') {
        setTimeout(() => {
          // this.$refs.dateTo.data.minDate(val)
          this.options4.minDate = moment(val).format('MM/DD/YYYY')
          this.keyValueUpdate++;
        }, 100)
        this.callDateRange()
        this.fromDateValidation()
        if(this.isDateRangeDisable) {
          setTimeout(() => {
              this.dateFrom = ''
              this.dateTo = ''
          }, 100)
        }
      }
    },
    dateTo(val) {
      if (val != null && this.dateFrom != null && val != '') {
        setTimeout(() => {
          // this.$refs.dateFrom.data.maxDate(val)
          this.DatePickerOptions.maxDate = moment(val).format('MM/DD/YYYY')
          this.Count++;
        }, 100)
        this.callDateRange()
        //this.updateToDatePicker(this.dateFrom)
        this.fromDateValidation("dateTo")
        if(this.isDateRangeDisable) {
          setTimeout(() => {
              this.dateFrom = ''
              this.dateTo = ''
          }, 100)
        }
      }
    },
    timesheetId(val) {
      if (val != null && val != '') {
        this.getTimesheetDetails()
      }
    },
    projectSelected(val) {
      if (val != null && val != '') {
        this.onProjectSelected(val);
        this.getTimeSheetCycleName(this.timesheetCycle);
      }
    },
    employeeSelected(val) {
      if (val != null && val != '') {
        this.getselectedEmployeeId(val);
        this.getselectedEmployeeData()
        if(this.isDateRangeDisable) {
          setTimeout(() => {
              this.dateFrom = ''
              this.dateTo = ''
          }, 100)
        }
      }
    },
    TimesheetType(val) {
      ;
      if (val == 'TimesheetOnly') {
        this.tooltipContent = `You can save the ${this.timesheetLabel}(s) now and approve later.`
      }
      else if (val == 'ExpensesOnly') {
        this.tooltipContent = 'You can save the Expense(s) now and approve later.'
      }
      else {
        this.tooltipContent = `You can save the ${this.timesheetLabel}(s) and Expense(s) now and approve later.`
      }
    },
    isDateRangeDisable(val) {
      if(val) {
        setTimeout(() => {
            this.dateFrom = ''
            this.dateTo = ''
        }, 100)
      }
    }
  },
  computed: {
    IsValidHours() {
      if (this.TimesheetType == 'TimesheetOnly') {
        return true;
        // if(this.TotalTimesheetHours != undefined && this.TotalTimesheetHours != '0h 0m')
        // {
        //   return true;
        // }
      }
      else if (this.TimesheetType == 'ExpensesOnly') {
        if (this.totalExpensesAmount != undefined && this.totalExpensesAmount != 0) {
          return true
        }
      }
      else if (this.TimesheetType == 'TimesheetAndExpenses') {
        if ((this.TotalTimesheetHours != undefined && this.TotalTimesheetHours != '0h 0m') && (this.totalExpensesAmount != undefined && this.totalExpensesAmount != 0)) {
          return true;
        }
      }
      return false;
    },
    TotalTimesheetHours() {

      return this.DetailMode ? this.TotalHoursWorked : this.QuickModeTotalHours
    },
    isExpensesDisabled() {
      if (this.TimesheetOrExpense == 'timesheet') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.TimesheetType = 'TimesheetOnly';
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isTimesheetDisabled = false;
        return true
      }
      else if (this.TimesheetOrExpense == 'expense') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.TimesheetType = 'ExpensesOnly'
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isTimesheetDisabled = true;
        return false
      }
      else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.TimesheetType = 'TimesheetOnly'
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isTimesheetDisabled = false;
        return false
      }
    },
    isTimesheetExpensesDisabled() {
      if (this.timeSheetDetails.TimeSheetStatus == "Approved" || this.timeSheetDetails.TimeSheetStatus == "Rejected" || this.ExpenseStatus == "Approved" || this.ExpenseStatus == "Rejected")
        return true
      else return false
    },
    candidateListOptions() {
      var options = {}
      options.placeholder = {
        id: '-1', // the value of the option
        text: 'Select'
      }
      var data = this.candidatesOptionList.filter(l => l.EmployeeId != '')
      options.data = data
      var template = function (data) {
        let result = '';
        result += '<div style="width:220px"><div class="row "><div class="col-md-12"><div style="font-weight: 600;font-size: 15px;width: 270px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">' + data.Name + (data.Email ? ` (${data.Email})` : '') + '</div></div></div>'
        result += '<div class="row" style="padding-top:10px"><div class="col-md-5">' + '<img :src="' + c.CDNIMAGESBASEURL + '/ess/ESSApp/static/Images/ic_endclient.svg" style="width:15px;margin-bottom:4px;float:left"/>' + '<div style="padding-left:5px;width: 50px;white-space:nowrap;text-overflow: ellipsis;overflow: hidden;">' + data.HireType + '</div>' + '</div><div style="float:left;height:15px;width:1px;background-color:gray;margin-left:-35px"></div><div style="padding-left:10px;width:180px;white-space:nowrap;text-overflow: ellipsis;overflow:hidden;margin-left:-35px" class="col-md-6">' + data.Designation + '</div></div>'
        return $(result);
      }
      options.templateResult = template

      options.matcher = function(params, data) {
        if ($.trim(params.term) === '') {
            return data;
        }
        const term = params.term.toLowerCase();
        const name = data.Name ? data.Name.toLowerCase() : '';
        const email = data.Email ? data.Email.toLowerCase() : '';
        // Allow searching by any of these fields
        if (name.includes(term) || email.includes(term)) {
            return data;
        }
        return null;
      };
      return options;
    },
    projectListOptions() {
      var options = {}
      options.placeholder = {
        id: '-1', // the value of the option
        text: 'Select'
      }
      var data = this.TimesheetProjectList.filter(l => l.ProjectId != '')
      options.data = data
      var template = function (data) {
        let result = '';
        if (data.id != 'Project unavailable') {
          result += '<div style="width:200px"><div class="row "><div class="col-md-12"><div style="font-weight: 600;font-size: 15px;width: 180px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">' + data.ProjectTitle + '</div></div></div>'
          result += '<div class="row" style="padding-top:10px"><div class="col-md-6">' + '<img :src="' + c.CDNIMAGESBASEURL + '/ess/ESSApp/static/Images/ic_endclient.svg" style="width:15px;margin-bottom:4px;float:left"/>' + '<div style="padding-left:5px;width: 70px;white-space:nowrap;text-overflow: ellipsis;overflow: hidden;">' + data.EndClientName + '</div>' + '</div><div style="float:left;height:15px;width:1px;background-color:gray"></div><div class="col-md-5">' + data.Status + '</div></div>'
          result += '<div class="row" style="padding-top:10px"><div class="col-md-12">' + '<img :src="' + c.CDNIMAGESBASEURL + '/ess/ESSApp/static/Images/ic_projectperiod.svg" style="width: 15px;margin-bottom:4px"/>' + '<span style="padding-left:5px">' + data.StartDate + " to " + data.EndDate + '</span>' + '</div></div></div>'
        } else {
          result += '<div style="width:200px"><div class="row "><div class="col-md-12"><div style="font-weight: 600;font-size: 15px;width: 180px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">' + "Project unavailable" + '</div></div></div>'
        }
        return $(result);
      }
      options.templateResult = template
      return options;
    },
    attachmentCount() {
      if (this.Attachments.length > 0)
        return this.Attachments.length
    },
    AlertProjectId() {
      if (this.$route.query.startDate != null && this.$route.query.endDate != null && this.$route.query.project != null) {
        var project = this.projectList.filter(v => v.ProjectId == this.$route.query.project)[0]
        return project.ProjectId
      }
    },
    TotalHoursWorked() {
      var hrs = 0;
      var min = 0
      for (var i = 0; i < this.WorkSheets.length; i++) {
        var total = (this.WorkSheets[i].totalTime).split(' ')
        if (total[0]) {
          var h = total[0]
          var m = total[1]
          if (h) {
            hrs = hrs + (parseInt(h.replace("h ", "")) || 0)
          } if (m) {
            min = min + (parseInt(m.replace("m", "")) || 0)
          }
        }
      }
      var hours = (min / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      var totalHours = parseInt(hrs) + parseInt(rhours);
      let _totalhoursWorked = (parseInt(totalHours) || 0) + "h " + (parseInt(rminutes) + "m") || 0;
      this.QuickModeTotalHours = _totalhoursWorked
      return _totalhoursWorked;
    },
    diasbleApprovalButton() {
      if (this.IsCoincide == true) {
        return true
      }
      else return false
    },
    OrganisationId() {
      return this.loggedInUserObj.orgId ? this.loggedInUserObj.orgId : '';
    },
    EmployeeId() {
      return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
    },
    projectsCount() {
      if (this.projectList && this.projectList != null && this.projectList.length > 1) {
        return this.projectList.length
      }
    },
    projectName() {
      for (var i = 0; i < this.projectList.length; i++) {
        if (this.projectSelected == this.projectList[i].ProjectId) {
          return this.projectList[i].ProjectTitle
        }
      }
    },
    DatePickerOptions() {
      let options = {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        maxDate: moment().add(1, 'months'),
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
        }
      }
      var project = [];
      if (this.projectList.length > 0) {
        project = this.projectList.filter(v => v.ProjectId == this.projectSelected)[0]
        if (project != "" && project != null) {
          var projectStartDate = moment(project.ProjectStartDate);
          var fromMinDate;
          if(this.employmentStartDate) {
            var employmentStartDate = moment(this.employmentStartDate)
            fromMinDate = employmentStartDate.isBefore(projectStartDate) ? projectStartDate : employmentStartDate
          }
          else {
            fromMinDate = projectStartDate
          }
          setTimeout(() => {
            if((!this.IsAllowFutureDate && this.timesheetCycle === 'Custom' )){
              var minDt = moment(this.PreviousDate).format('MM/DD/YYYY');
              this.$refs.dateFrom.data.minDate(minDt)
            }
            else if (!this.IsAllowFutureDate && this.TimeSheetStatus == 'EmployerRequestToResubmit') {
            setTimeout(() => {
              this.$refs.dateFrom.data.minDate(fromMinDate.format('MM/DD/YYYY'))
              }, 100)
            }
            else if ((this.IsAllowFutureDate)) {
            this.$refs.dateFrom.data.minDate(fromMinDate.format('MM/DD/YYYY'))
            }
          }, 100)
        }
        else {
            setTimeout(() => {
              this.employmentStartDate ? this.$refs.dateFrom.data.minDate(moment(this.employmentStartDate).format('MM/DD/YYYY')) : ''
            }, 100)
          }
      }
      else {
          setTimeout(() => {
            this.employmentStartDate ? this.$refs.dateFrom.data.minDate(moment(this.employmentStartDate).format('MM/DD/YYYY')) : ''
          }, 100)
      }
      return options
    },
    CheckRegularDistributionHours() {
      var sheets = this.QuickModeWorkSheets
      var count = 0
      var min = 0;
      var hrs = 0;
      for (var i = 0; i < this.QuickModeWorkSheets.length; i++) {
        var weekday = sheets[i]
        for (var j = 0; j < weekday.length; j++) {
          if (weekday[j].IsWeekDay == true) {
            var y;
            let preHrs;
            var previousRTWorkHours = this.PreviousWorkHours.find(v => v.Date == weekday[j].Date) ? this.PreviousWorkHours.find(v => v.Date == weekday[j].Date).RegularHours : "0h";
            y = previousRTWorkHours.split(' ');
            preHrs = y[0] ? parseInt(y[0].replace("h ", "")) : "0";
            let preMin = y[1] ? parseInt(y[1].replace("m", "")) : "0";
            hrs = parseInt(hrs) + parseInt(preHrs);
            min = parseInt(min) + parseInt(preMin);
            count = count + 1
          }
        }
      }
      var limit = count * (this.MaximumRegulerTimesheetHours)
      if (this.RegularDistributionMinutes != '') {
        min = parseInt(min) + parseInt(this.RegularDistributionMinutes)
      }
      if (this.RegularDistributionHours != '') {
        hrs = parseInt(hrs) + parseInt(this.RegularDistributionHours)
      }
      var hours = (min / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      var totalHours = parseInt(hrs) + parseInt(rhours);
      if (this.MaximumRegulerTimesheetHours == 0) {
        return false
      }
      else if ((totalHours == limit) && rminutes > 0) {
        return true
      }
      else if (totalHours > limit) {
        return true
      }
      else {
        return false
      }
    },
    isCommentsValid() {
      if ((this.IsDCAAComplianceToggleOn == true) && (this.isSavedClicked == true) && (this.Comments == undefined || this.Comments == null || this.Comments == '')) {
        return false;
      }
      else {
        return true;
      }
    },
    isDateRangeDisable() {
      if((this.employmentStartDate == '' || this.employmentStartDate == null || this.employmentStartDate == undefined) && this.selectedEmployeeID != null && this.selectedEmployeeID != '') {
        return true
      }
      let disable = false;
      const today = moment();
      const empStartDate = moment(this.employmentStartDate)
      disable = empStartDate.isAfter(today)
      if(disable) {
        setTimeout(() => {
            this.dateFrom = ''
            this.dateTo = ''
        }, 100)
      }
      return disable
    }
  },
  created() {
    if (this.$route.query.TimesheetId) {
      this.timesheetId = this.$route.query.TimesheetId
    }
    else {
      setTimeout(() => {
        this.getProjectList()
      }, 200)
    }
    setTimeout(() => {
      if (this.$route.query.from != 'employer-timesheets') {
        this.getTaskList()
      }
    }, 200)

    setTimeout(() => {
      if (this.$route.query.from == 'employer-timesheets') {
        this.getAssignedTrianeeList()
      }
    }, 200)
    if (this.$route.query.Type) {
      this.TimesheetOrExpense = this.$route.query.Type
    }
    if (this.$route.query.Status) {
      this.TimeSheetStatus = this.$route.query.Status
    }
    this.getTimeSheetSettings()
  },
  methods: {
    IsDescEdited(TaskId, desc, taskIndex, sheetIndex){
      for (var i = 0; i < this.WorkSheets.length; i++) {
        for (var j = 0; j < this.WorkSheets[i].tasksList.length; j++) {

          if(this.WorkSheets[i].tasksList[j].TaskId == TaskId)
          {
            this.WorkSheets[i].tasksList[j].TaskDescription = desc;
            this.WorkSheets[i].tasksList[j].IsTaskEdited = true;
          }
        }
      }
      this.taskOptions.data.forEach((t) => {
          if (t.id == TaskId) {
            t.description = desc ;
          }
        })
    },
    HandleAfterTaskUpdate(val){
      this.showTaskSelect2 = false
      if(this.taskOptions != null && this.taskOptions.data != null && val != null)
      {
        var index = this.taskOptions.data.findIndex(x=>x.id == val.TaskId);

        this.taskOptions.data[index].text = val.Title;

        setTimeout(() => {
            this.showTaskSelect2 = true
          }, 10)
      }
    },
    updateparent(variable) {
      this.ExpenseModel = variable
    },
    OnselectedTimesheetType(type) {
      let expenseModel = [];
      if (this.TimesheetType != 'TimesheetOnly') {
        if (this.$refs.timesheetExpenses != undefined && this.$refs.timesheetExpenses != null) {
          expenseModel = this.$refs.timesheetExpenses.formatTimesheetExpanseObjectToSave();
        }
      }
      if (type == 'ExpensesOnly') {
        if (expenseModel != null && expenseModel != undefined && expenseModel.length == 0) {
          this.ExpenseModel.push({
            Id: '',
            ExpenseType: '',
            ExpenseAmount: '',
            ExpenseDetails: '',
            PaymentType: 'CompanyPaid',
            AttachmentUrls: [],
            SpecifyReason: '',
            isAttachementreq: false,
          })
          if (this.$refs.timesheetExpenses != undefined && this.$refs.timesheetExpenses != null) {
            this.$refs.timesheetExpenses.formatTimesheetExpanseObjectForGet()
          }
        }
      }
      else if (type == 'TimesheetAndExpenses') {
        if (expenseModel != null && expenseModel != undefined && expenseModel.length == 0 && this.$refs.timesheetExpenses != undefined && this.$refs.timesheetExpenses != null) {
          this.$refs.timesheetExpenses.formatTimesheetExpanseObjectForGet()
        }
      }
    },
    descTask(obj,sheetIndex,taskIndex){
      var taskId = obj.TaskId
      var empId = this.selectedEmployeeID != '' &&  this.selectedEmployeeID != null ? this.selectedEmployeeID : this.EmployeeId ;

      this.$loading({loadingText: 'Please wait...'});
      ajax.get(`/Task/${taskId}/${empId}`, {}, (res) => {
        if(res.data.State == true){
          this.previousData = res.data.TaskMetaData;
          this.previousData['EmployeeId'] = empId;

          this.previousData['IsDisableUpdate'] = this.$route.name == 'employer-timesheets' || this.$route.name == "employer-addtimesheets" || (this.$route.query && this.$route.query.from == 'employer-timesheets') || (this.$route.query && this.$route.query.from == 'employer-addtimesheets') ||
                                                (this.previousData.CreatedBy != null && this.previousData.CreatedBy.Email == this.loggedInUserObj.email) ? false : true;
          //this.previousData.CurrentRole == 'HRManager'
        }
        this.WorkSheets[sheetIndex].tasksList[taskIndex].IsDescDisabled = this.previousData['IsDisableUpdate']
        this.WorkSheets[sheetIndex].tasksList[taskIndex].TaskDescription = this.previousData.Description
        this.WorkSheets[sheetIndex].tasksList[taskIndex].IsTaskEdited = false

        this.$loading({}).close();
      })
    },
    updateTaskList(title, sheetIndex, taskIndex) {
      if (title && title != null && title != '') {
        var isTaskExists = false
        this.taskOptions.data.forEach((t) => {
          if (t.id == title) {
            isTaskExists = true
            return;
          }
        })
        if (isTaskExists == false) {
          this.$loading({ 'loadingText': 'Loading...' })
          // this.taskOptions.data.push({'id': title, 'text' : title})
          this.bindingReqObjectForAddTask(title, sheetIndex, taskIndex)
          this.showTaskSelect2 = false
          setTimeout(() => {
            this.$loading({ 'loadingText': 'Loading...' }).close()
            this.showTaskSelect2 = true
          }, 1000)
        }
        else{
          this.WorkSheets[sheetIndex].tasksList[taskIndex].IsTaskEdited = false
          var task = this.taskOptions.data.find(x=>x.id == title);
          this.WorkSheets[sheetIndex].tasksList[taskIndex].TaskDescription =  task.description

          this.WorkSheets[sheetIndex].tasksList[taskIndex].IsTaskDisabled =  !(task.createdByEmail == undefined || task.createdByEmail == this.loggedInUserObj.email)
        }
      }
    },
    OnDistributionPopupCancel() {
      this.$v.RegularDistributionHours.$reset()
      this.$v.RegularDistributionMinutes.$reset()
      this.$v.OverTimeDistributionMinutes.$reset()

      this.RegularDistributionHours = '',
        this.RegularDistributionMinutes = '',
        this.OverTimeDistributionHours = '',
        this.OverTimeDistributionMinutes = '',
        this.showTimeDistributionPopup = false
    },
    openTimeDistributionPopup(val) {
      var quickList = this.$refs.quicktimesheets.QuickTimesheetList;
      if (val == 'EDIT') {
        var regularMins = 0
        var OverMins = 0
        for (var i = 0; i < quickList.length; i++) {
          var item = quickList[i];
          for (var j = 0; j < item.length; j++) {
            let x = item[j];
            if (x.tasksList.Hours != '' && x.tasksList.Minutes != null) {
              regularMins = (parseInt(regularMins) || 0) + (60 * parseInt(x.tasksList.Hours) || 0) + (parseInt(x.tasksList.Minutes) || 0);
            }
            if (x.tasksList.OverTimeHours != '' && x.tasksList.OverTimeMinutes != null) {
              OverMins = (parseInt(OverMins) || 0) + (60 * parseInt(x.tasksList.OverTimeHours) || 0) + (parseInt(x.tasksList.OverTimeMinutes) || 0);
            }
          }
        }

        var totalRegularMinutes = regularMins;
        this.RegularDistributionHours = Math.floor(totalRegularMinutes / 60);
        this.RegularDistributionMinutes = parseInt(totalRegularMinutes % 60);

        var totalOverMinutes = OverMins;
        this.OverTimeDistributionHours = Math.floor(totalOverMinutes / 60);
        this.OverTimeDistributionMinutes = parseInt(totalOverMinutes % 60);
      }
      else {
        this.RegularDistributionHours = '',
          this.RegularDistributionMinutes = '',
          this.OverTimeDistributionHours = '',
          this.OverTimeDistributionMinutes = '';
      }

      this.showHoursEnterPopover = false;
      this.showTimeDistributionPopup = true;
    },
    OnDistributionHoursEnter(val) {
      this.$v.RegularDistributionHours.$touch();
      this.$v.RegularDistributionMinutes.$touch();
      this.$v.OverTimeDistributionMinutes.$touch();

      if (!this.$v.RegularDistributionHours.$error && !this.$v.RegularDistributionMinutes.$error && !this.$v.OverTimeDistributionMinutes.$error && !this.CheckRegularDistributionHours) {
        var regularMin = (parseInt(this.RegularDistributionHours) * 60 || 0) + (parseInt(this.RegularDistributionMinutes) || 0);
        var overtimeMins = (parseInt(this.OverTimeDistributionHours) * 60 || 0) + (parseInt(this.OverTimeDistributionMinutes) || 0);
        if (!this.IsQuickMode && (regularMin > 0 || overtimeMins > 0)) {
          this.$refs.quicktimesheets.minsAutoFill(regularMin, overtimeMins);
        }
        this.OnDistributionPopupCancel();
      }
    },
    IsWeekDay(date) {
      var day = moment(date).format('dddd');
      if (day == 'Sunday' && this.IsSunday) {
        return true;
      }
      else if (day == 'Monday' && this.IsMonday) {
        return true;
      }
      else if (day == 'Tuesday' && this.IsTuesday) {
        return true;
      }
      else if (day == 'Wednesday' && this.IsWednesday) {
        return true;
      }
      else if (day == 'Thursday' && this.IsThursday) {
        return true;
      }
      else if (day == 'Friday' && this.IsFriday) {
        return true;
      }
      else if (day == 'Saturday' && this.IsSaturday) {
        return true;
      }
      return false;
    },
    onHrsClick() {
      if (this.dateFrom != "" && this.dateTo != "" && !this.DetailMode) {
        this.isHoursEntered = true
      }
    },
    sendHours() {
      if (!this.IsQuickMode && this.directHoursEntered != '') {
        this.$refs.quicktimesheets.hoursAutoFill(this.directHoursEntered);
        this.isHoursEntered = false;
      }
    },
    closeExpensePopover() {
      if (this.showHoursEnterPopover == true)
        this.showHoursEnterPopover = false;
    },
    OnGotItClick() {
      this.OkGotIt = true;
      this.showPopover = false
      this.closeExpensePopover()
    },
    hoursEntered(info) {
      var el = document.querySelector('.total-hours');
      setTimeout(() => {
        this.showHoursEnterPopover = true;
        setTimeout(() => {
          createPopper(el, this.$refs.expensePopoverWrapper, {
            placement: "top"
          });
        }, 0);
      }, 0);
    },
    TimesheetCancel() {
      if (this.$route.query.listView) {
        this.$router.push({ 'path': '/timesheets-list', query: { listView: "true" } })
      }
      else {
        this.$router.push({ name: "employer-timesheets" });
      }
    },
    // getselectedEmpName(id){
    //   this.EmpList.forEach(d => {
    //     if(d.EmployeeId == id){
    //       this.selectedEmpName = d.Name
    //       console.log("slelected emo na,e",this.selectedEmpName)
    //     }
    //   });
    // },
    getselectedEmployeeId(val) {
      this.$loading({ loadingText: 'Please wait...' });
      this.dateFrom = '';
      this.dateTo = '';
      this.WorkSheets.length = 0;
      var project = this.EmpList.filter(v => v.EmployeeId == val);
      this.selectedEmployeeID = project[0].EmployeeId;
      this.getProjectList();
      this.getTaskList()
      // this.getselectedEmpName(val)
      this.$loading({}).close();
    },
    getCandidatesOptionList() {
      setTimeout(() => {
        this.showEmployeeList = true
      }, 10)

      let C2C1099Candidates = []
      for (var i = 0; i < this.EmpList.length; i++) {
        if (this.EmpList[i].HireType != "W2") {
          C2C1099Candidates.push(this.EmpList[i]);
        }
      }

      if (this.checkedC2C) {
        var finalCandidatesList = [...C2C1099Candidates]
      }
      else {
        finalCandidatesList = [...this.EmpList]
      }
      this.candidatesOptionList = __.map(finalCandidatesList, (c) => {
        return {
          "id": c.EmployeeId,
          "text": c.Name,
          "Name": c.Name,
          "Designation": c.Designation,
          "HireType": c.HireType,
          "Email": c.Email,
          "EmploymentStartDate": c.EmploymentStartDate,
        }
      })
    },
    getAssignedTrianeeList() {
      this.showEmployeeList = false
      ajax.get(`/Supervisor/GetReportingEmployeeList?empId=${this.EmployeeId}`, {}, (res) => {
        if (res.data.resultList.length > 0) {
          this.EmpList = res.data.resultList;
          this.getCandidatesOptionList()
        }
        else {
          this.$message({
            type: 'error',
            message: res.data.Message
          })
        }
      })
    },
    getProjectOptionList() {
      setTimeout(() => {
        this.showProjectOptions = true
      }, 10)

      let OngoingList = []
      let CompletedList = []
      for (var i = 0; i < this.projectList.length; i++)
        if (this.projectList[i].Status === "On-Going") {
          OngoingList.push(this.projectList[i]);
        } else {
          CompletedList.push(this.projectList[i])
        }

      if (this.isChecked) {
        if (CompletedList.length == 0) {
          this.projectSelected = ''
        }
        var finalProjectList = [...CompletedList]
      }
      else {
        if (OngoingList.length == 0) {
          this.projectSelected = ''
        }
        finalProjectList = [...OngoingList]
      }
      this.TimesheetProjectList = __.map(finalProjectList, (c) => {
        return {
          "id": c.ProjectId,
          "text": c.ProjectTitle,
          "ProjectTitle": c.ProjectTitle,
          "EndClientName": c.EndClientName,
          "Status": c.Status,
          "StartDate": c.ProjectStartDate,
          "EndDate": c.ProjectEndDate == '' || c.ProjectEndDate== '01/01/0001'? 'No Expiration' : c.ProjectEndDate,
        }
      })
      this.TimesheetProjectList.unshift({
        id: 'Project unavailable', text: 'Project unavailable',
        "ProjectTitle": '',
        "EndClientName": '',
        "Status": '',
        "StartDate": '',
        "EndDate": ''
      });
    },
    compareMaxHours(worksheet, val) {
      var hrs = 0;
      var min = 0;
      var h = parseInt(val) ? parseInt(val) : '0';
      if (worksheet.totalTime != '') {
        for (var i = 0; i < worksheet.tasksList.length; i++) {
          var timesheet = worksheet.tasksList[i];
          if (timesheet.Hours == '') {
            hrs = hrs + 0
          }
          else {
            hrs = hrs + parseInt(timesheet.Hours)
          }
          if (timesheet.Minutes == '') {
            min = min + 0
          }
          else {
            min = min + parseInt(timesheet.Minutes)
          }
        }
        var previousRTWorkHours = this.PreviousWorkHours.find(v => v.Date == worksheet.Date) ? this.PreviousWorkHours.find(v => v.Date == worksheet.Date).RegularHours : "0h";
        var y = previousRTWorkHours.split(' ');
        let preHrs = 0;
        let preMin = 0;
        if (y.length == 2) {
          preHrs = y[0] ? parseInt(y[0].replace("h ", "")) : "0";
          preMin = y[1] ? parseInt(y[1].replace("m", "")) : "0";
        }
        else if (y.length == 1) {
          if (y[0].includes('h')) {
            preHrs = preHrs + (parseInt(y[0].replace('h', '')) || 0);
          }
          else if (y[0].includes('m')) {
            preMin = preMin + (parseInt(y[0].replace('h', '')) || 0);
          }
        }
        hrs = hrs + parseInt(preHrs);
        min = min + parseInt(preMin);
        var hours = (min / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        var totalHours = parseInt(hrs) + parseInt(rhours);
        if (this.MaximumRegulerTimesheetHours == 0) {
          return false
        }
        else if (totalHours == this.MaximumRegulerTimesheetHours && rminutes > 0 && h > 0) {
          return true
        }
        else if ((totalHours > this.MaximumRegulerTimesheetHours) && h > 0) {
          return true
        }
        else {
          return false
        }
      }
    },
    IsPreviousRTHoursExist(worksheets) {
      var x = this.PreviousWorkHours.find(v => v.Date == worksheets.Date) ? this.PreviousWorkHours.find(v => v.Date == worksheets.Date).RegularHours : "0h";
      if (x != '0h')
        return true;
    },
    totalHoursvalidation(worksheets, val) {
      if (worksheets != undefined && worksheets != null && worksheets.totalTime != null && worksheets.totalTime != undefined) {
        var time = worksheets.totalTime;

        var x = time.split(' ');
        var h = parseInt(val) ? parseInt(val) : '0';


        let hrs = parseInt(x[0].replace("h ", ""));

        let min = parseInt(x[1].replace("m", ""));

        var total = parseInt(x[0] + x[1])
        if (hrs > 24 && h > 0) {
          return true
        }
        else if (hrs == 24 && min > 0 && h > 0) {
          return true
        }
        else return false
      }
    },
    expensesAmount(expenseamount) {
      this.totalExpensesAmount = expenseamount;
    },
    isValidExpenses(expensesValid) {
      this.isExpensesValid = expensesValid
    },
    totalHoursWorkedQuickMode(time) {
      this.QuickModeTotalHours = time;
    },
    // on DetailMode toggle click--converting quick mode data to detail mode
    FormatWorkItemsForDetailMode() {
      var quickList = this.$refs.quicktimesheets.QuickTimesheetList;
      var detailModeList = [];
      Array.prototype.forEach.call(quickList, item => {
        Array.prototype.forEach.call(item, x => {

          if (!x.isDisabled) {
            var obj = {
              "Date": x.Date,
              "DayType": x.DayType,
              "totalTime": x.totalTime,
              "tasksList": [
                {
                  "Date": x.tasksList.Date,
                  "Hours": x.tasksList.Hours,
                  "Minutes": x.tasksList.Minutes,
                  "OverTimeHours": x.tasksList.OverTimeHours,
                  "OverTimeMinutes": x.tasksList.OverTimeMinutes,
                  "ProjectId": x.tasksList.ProjectId,
                  "TaskId": x.tasksList.TaskId,
                },
              ],
              "show": true,
              "IsWeekDay": x.IsWeekDay
            }
            detailModeList.push(obj)
          }
        })
      })
      this.WorkSheets = [...detailModeList]
      this.caliculateTotalTime();
    },
    // on QuickMode toggle click--converting Detail mode data to Quick mode
    FormatWorkItemsForQuickMode() {
      //get dates for Disabled Dates
      var datefrom = moment(this.dateFrom).format('MM/DD/YYYY');
      var dateTo = moment(this.dateTo).format('MM/DD/YYYY');
      const week_start_date = moment(datefrom).startOf('week').format('MM/DD/YYYY');
      const week_end_date = moment(dateTo).endOf('week').format('MM/DD/YYYY');
      var fromDateDiffList = this.EnumerateDaysBetweenDates(moment(week_start_date), moment(datefrom).add(-1, 'days'));
      var toDateDiffList = this.EnumerateDaysBetweenDates(moment(dateTo).add(1, 'days'), moment(week_end_date));
      var totalRemainedDaysArrayList = fromDateDiffList.concat(toDateDiffList);

      var totalRemainedDWorkItemList = [];
      Array.prototype.forEach.call(totalRemainedDaysArrayList, item => {
        var task = { ProjectId: '', TaskId: '', Date: '', Hours: '', Minutes: '', OverTimeHours: '', OverTimeMinutes: '' }
        let localObj = {
          Date: item,
          DayType: 'None',
          totalTime: '0 Hours',
          tasksList: task,
          isDisabled: true,
          show: true,
          IsWeekDay: false
        }
        totalRemainedDWorkItemList.push(localObj);
      })
      //formating Existing Workitems as Quick list
      var ExistingWorkItems = [];

      Array.prototype.forEach.call(this.WorkSheets, item => {

        let H = 0;
        let M = 0;
        let OTH = 0;
        let OTM = 0;
        Array.prototype.forEach.call(item.tasksList, task => {
          H = H + (parseInt(task.Hours) || 0);
          M = M + (parseInt(task.Minutes) || 0);
          OTH = OTH + (parseInt(task.OverTimeHours) || 0);
          OTM = OTM + (parseInt(task.OverTimeMinutes) || 0);
        });



        let hours = (M / 60);
        let rhours = Math.floor(hours);
        let minutes = (hours - rhours) * 60;
        let rminutes = Math.round(minutes);
        let totalHours = parseInt(H) + parseInt(rhours);

        totalHours = totalHours == 0 ? '' : totalHours;
        rminutes = rminutes == 0 ? '' : rminutes;

        let OThours = (OTM / 60);
        let OTrhours = Math.floor(OThours);
        let OTminutes = (OThours - OTrhours) * 60;
        let OTrminutes = parseInt(Math.round(OTminutes)) || 0;
        let OTtotalHours = parseInt(OTH) + parseInt(OTrhours) || 0;

        OTtotalHours = OTtotalHours == 0 ? '' : OTtotalHours;
        OTrminutes = OTrminutes == 0 ? '' : OTrminutes;

        var task = { ProjectId: '', TaskId: '', Date: item.Date, Hours: totalHours.toString(), Minutes: rminutes.toString(), OverTimeHours: OTtotalHours.toString(), OverTimeMinutes: OTrminutes.toString() }

        let obj = {
          Date: item.Date,
          DayType: item.DayType,
          totalTime: '0 Hours',
          tasksList: task,
          isDisabled: false,
          show: true,
          IsWeekDay: item.IsWeekDay
        }
        totalRemainedDWorkItemList.push(obj);
      });
      var quickWorkSheets = totalRemainedDWorkItemList.sort(function (a, b) {
        return new Date(a.Date) - new Date(b.Date);
      })

      this.QuickModeWorkSheets = [];

      /// converting as double array list(calender view)
      let i = 0;
      let j = 0;
      for (i = 0; i < quickWorkSheets.length; i++) {
        var x = [];
        for (j = 0; j < 7; j++) {
          x.push(quickWorkSheets[i]);
          i++;
        }
        i--;
        this.QuickModeWorkSheets.push(x);
      }
    },
    EnumerateDaysBetweenDates(startDate, endDate) {
      var now = startDate, dates = [];
      while (now.isSameOrBefore(endDate)) {
        dates.push(now.format('MM/DD/YYYY'));
        now.add(1, 'days');
      }
      return dates;
    },
    onQuickClick() {
      if (this.DetailMode) {
        this.FormatWorkItemsForQuickMode();
      }
      this.DetailMode = false
      if (this.showPopover) {
        this.hoursEntered()
      }
      document.querySelector('.add-timesheets').scrollTop = 0;
    },
    onDetailClick() {
      if (!this.DetailMode) {
        this.FormatWorkItemsForDetailMode();
      }
      this.DetailMode = true
      this.closeExpensePopover()
      this.isHoursEntered = false;
    },
    validateAttachments() {
      if (this.timesheetAttachments) {
        if (this.attachmentCount > 0) {
          this.isValidate = false
        } else {
          this.isValidate = true
        }
      } else {
        this.isValidate = false
      }
    },
    updateToDatePicker(fromDate) {
      var FromDate = moment().format('MM/DD/YYYY');
      var maxDt;
      var minDt;
      let projectEndDate = this.ProjectEndDate ? moment(this.ProjectEndDate) : moment().add(1, 'years'); 
      if (!this.IsAllowFutureDate) {
        if (this.timesheetCycle == 'Weekly' || this.timesheetCycle == 'None') {
          const weekStart = moment().startOf('week');
          minDt = weekStart.format('MM/DD/YYYY');
          maxDt = weekStart.clone().add(6, 'days').format('MM/DD/YYYY');
        }
        else if (this.timesheetCycle == 'BiWeekly') {
        const weekStart = moment().startOf('week'); 
        minDt = weekStart.format('MM/DD/YYYY');
        maxDt = weekStart.add(13, 'days').format('MM/DD/YYYY'); 
      }        
        else if (this.timesheetCycle == 'SemiMonthly') {
        const currentDayNo = parseInt(moment().format('DD'));

        if (currentDayNo <= 15) {
          minDt = moment().startOf('month').format('MM/DD/YYYY'); // 1st of month
          maxDt = moment().startOf('month').add(14, 'days').format('MM/DD/YYYY'); 
        } else {
          minDt = moment().startOf('month').add(15, 'days').format('MM/DD/YYYY'); 
          maxDt = moment().endOf('month').format('MM/DD/YYYY'); // end of month
        }
      }
        else if (this.timesheetCycle == 'Monthly') {
        minDt = moment().startOf('month').format('MM/DD/YYYY');
        maxDt = moment().endOf('month').format('MM/DD/YYYY'); 
      }
        else if (this.timesheetCycle == 'Custom') {
          var x = moment(this.PreviousDate).format('MM/DD/YYYY');
          maxDt = moment(this.project[0].FromDate).add(1, 'months');
          minDt = x;
        }
        else {
          maxDt = moment().add(1, 'months');
        }
        var date1 = new Date(this.ProjectEndDate)
        var date2 = new Date(maxDt)
        if (date1 < date2) {
          setTimeout(() => {
            this.DatePickerOptions.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY')
            this.options4.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY')
            this.Count++;
            this.keyValueUpdate++;
          }, 100)
          if (new Date(this.ProjectEndDate) < new Date(this.dateFrom)) {
            this.dateFrom = this.ProjectEndDate
          }
          if (new Date(this.ProjectEndDate) < new Date(this.dateTo)) {
            this.dateTo = this.ProjectEndDate
          }
        }
        else {
          setTimeout(() => {
            // this.$refs.dateTo.data.maxDate(maxDt)
            // this.$refs.dateFrom.data.maxDate(maxDt)
            this.DatePickerOptions.minDate = minDt
            this.options4.maxDate = maxDt
            this.Count++;
            this.keyValueUpdate++;
            

          }, 200)
        }
      }
      else {
        var date1 = new Date(this.ProjectEndDate)
        var date2 = new Date()
        if (date1 < date2) {
          setTimeout(() => {
            this.DatePickerOptions.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY')
            this.options4.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY')
            this.Count++;
            this.keyValueUpdate++;
          }, 100)
          if (new Date(this.ProjectEndDate) < new Date(this.dateFrom)) {
            this.dateFrom = this.ProjectEndDate
          }
          if (new Date(this.ProjectEndDate) < new Date(this.dateTo)) {
            this.dateTo = this.ProjectEndDate
          }
        }
        else {
      setTimeout(() => {
            // this.$refs.dateTo.data.maxDate(moment())
            // this.$refs.dateFrom.data.maxDate(moment())
         
          if(!this.IsAllowFutureDate){
          this.DatePickerOptions.minDate = null; 
          this.options4.minDate = null;
          }
          if (this.ProjectEndDate) {
            this.DatePickerOptions.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY');
            this.options4.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY');
          } else {
            this.DatePickerOptions.maxDate = projectEndDate.format('MM/DD/YYYY');
            this.options4.maxDate = projectEndDate.format('MM/DD/YYYY');
          }
            this.Count++;
            this.keyValueUpdate++;
          }, 100)
        }

      }
    },

    getTimeSheetCycleName(Name) {
      if (Name == 'BiWeekly') {
        return 'Bi-Weekly'
      } else if (Name == 'SemiMonthly') {
        return 'Semi-Monthly'
      }
      else {
        return Name
      }
    },
    onProjectSelected(projectName) {
      var project = this.projectList.filter(v => v.ProjectId == projectName)
      this.project = project;
      if (projectName != this.AlertProjectId) {
        if (project.length > 0) {
          if (this.timesheetId == null || this.timesheetId == "" || this.timesheetId == undefined) {
            this.dateFrom = project[0].FromDate;
            this.PreviousDate = this.dateFrom;
            this.dateTo = project[0].ToDate;
            this.ProjectEndDate = project[0].ProjectEndDate
          }
        }
        else {
          if (this.timesheetId == null || this.timesheetId == "" || this.timesheetId == undefined) {
            this.dateFrom = '';
            this.dateTo = '';
            this.WorkSheets.length = 0;
          }
        }
      }
      else {
        //  this.projectSelected =  project.ProjectId
        this.dateFrom = this.$route.query.startDate;
        this.dateTo = this.$route.query.endDate;
        this.timesheetCycle = project.TimeSheetCycle;
        this.MaximumRegulerTimesheetHours = project.MaximumRegulerTimesheetHours;
        // this.IsSunday = project.IsSunday;
        // this.IsMonday = project.IsMonday;
        // this.IsTuesday = project.IsTuesday;
        // this.IsWednesday  = project.IsWednesday;
        // this.IsThursday  = project.IsThursday;
        // this.IsFriday  = project.IsFriday;
        // this.IsSaturday  = project.IsSaturday;
        this.IsAllowFutureDate = project.AllowFutureDatesInTimesheets;
        this.isTaskMandatory = project.MandateTasksInTimesheets;
        this.ProjectEndDate = project.ProjectEndDate;
      }
      if (project.length > 0) {
        this.timesheetCycle = project[0].TimeSheetCycle;
        this.MaximumRegulerTimesheetHours = project[0].MaximumRegulerTimesheetHours;
        this.timesheetAttachments = project[0].IsClientAttachmentsRequired;
        this.IsOverTimeApplicable = project[0].IsOverTimeApplicable;

        //  this.IsSunday = project[0].IsSunday;
        // this.IsMonday = project[0].IsMonday;
        // this.IsTuesday = project[0].IsTuesday;
        // this.IsWednesday  = project[0].IsWednesday;
        // this.IsThursday  = project[0].IsThursday;
        // this.IsFriday  = project[0].IsFriday;
        // this.IsSaturday  = project[0].IsSaturday;
        this.IsAllowFutureDate = project[0].AllowFutureDatesInTimesheets;
        this.isTaskMandatory = project[0].MandateTasksInTimesheets;
        this.ProjectEndDate = project[0].ProjectEndDate;
      }
      this.PreviousDate = this.dateFrom;
      if (this.timesheetCycle === "Custom" && project.length > 0 ) { 
        if(this.TimeSheetStatus == 'EmployerRequestToResubmit') {
        if(moment(project[0].FromDate) < moment(this.employmentStartDate)){
        this.PreviousDate = project[0].FromDate;
        }
        else{
          this.PreviousDate = this.employmentStartDate;
        }
      }
      else{
        this.PreviousDate = project[0].FromDate;

      }
      }
      this.onProjectChangeDataUpdate()
      setTimeout(() => {
        this.DatePickerOptions.maxDate = moment().format('MM/DD/YYYY');
        if(!this.IsAllowFutureDate){
        this.DatePickerOptions.maxDate = moment().format('MM/DD/YYYY');
        var today = moment().format('MM/DD/YYYY');
        if(today < this.dateFrom){
          this.DatePickerOptions.maxDate = this.dateFrom;
        }
        this.options4.maxDate = moment().format('MM/DD/YYYY');
        }
        this.Count++;
        this.keyValueUpdate++;
      }, 100)
      this.updateToDatePicker(this.dateFrom);
      // var e = {};
      // e['date'] = this.dateFrom;
      // this.onFromDateChange(e);
    },
    onProjectChangeDataUpdate() {
      if (this.projectSelected == 'Project unavailable') {


        this.timesheetCycle = '';
        this.MaximumRegulerTimesheetHours = 0;
        this.timesheetAttachments = false;
        this.IsOverTimeApplicable = false;
        this.getTimeSheetSettings()
      }

      if (this.DetailMode) {
        this.WorkSheets.forEach((t) => {
          var isWeekday = this.IsWeekDay(t.Date);
          Vue.set(t, 'IsWeekDay', isWeekday)
        })
      }
      else {
        this.QuickModeWorkSheets.forEach((m) => {
          m.forEach((t) => {
            var isWeekday = this.IsWeekDay(t.Date);
            Vue.set(t, 'IsWeekDay', isWeekday)
          })
        })
      }
    },
    holidayTypeDisplay(type) {
      if (type.DayType == 'FederalHoliday') {
        return "Note: This day has been declared as a federal holiday by your organization. However, you can add a timesheet for this day."
      }
      else if (type.DayType == 'Holiday') {
        return "Note: This day has been declared as Organization holiday by your Employer. However, you can add a timesheet for this day."
      }
      else if (type.DayType == 'Leave') {
        return "Note: You have an approved leave for this day. However, you can add a timesheet for this day."
      }
    },
    getProjectList() {
      this.$loading({ 'loadingText': 'Loading...' })
      this.projectList = []
      this.showProjectOptions = false
      var empId = this.$route.query.from == 'employer-timesheets' ? this.selectedEmployeeID : this.EmployeeId;
      var _that = this;
      ajax.get(`TimeSheets/GetOfferDetails?empId=${empId}`, {}, (res) => {
        if (res.data.State == true) {
          _that.projectSelected = ''
          _that.projectList = res.data.ProjectList
          _that.employmentStartDate = res.data && res.data.EmploymentStartDate ? moment(res.data.EmploymentStartDate).format('MM/DD/YYYY') : ''
          _that.AllowTimeSheetSubmissionOnHolidays = _that.projectList != null && _that.projectList.count != 0 && _that.projectList[0] != null ? _that.projectList[0].AllowTimeSheetSubmissionOnHolidays : false;
          if (_that.$route.query.startDate != null && _that.$route.query.endDate != null && _that.$route.query.project != null) {
            var project = _that.projectList.filter(v => v.ProjectId == _that.$route.query.project).length > 0 ? _that.projectList.filter(v => v.ProjectId == _that.$route.query.project)[0] : null;
            _that.dateFrom = _that.$route.query.startDate;
            _that.dateTo = _that.$route.query.endDate;
            if (project != null && project != '') {
              _that.timesheetAttachments = project.IsClientAttachmentsRequired;
              _that.projectSelected = project.ProjectId
              _that.timesheetCycle = project.TimeSheetCycle;
              _that.MaximumRegulerTimesheetHours = project.MaximumRegulerTimesheetHours;
              _that.IsOverTimeApplicable = project.IsOverTimeApplicable;
              // _that.IsSunday = project.IsSunday;
              // _that.IsMonday = project.IsMonday;
              // _that.IsTuesday = project.IsTuesday;
              // _that.IsWednesday  = project.IsWednesday;
              // _that.IsThursday  = project.IsThursday;
              // _that.IsFriday  = project.IsFriday;
              // _that.IsSaturday  = project.IsSaturday;
              _that.IsAllowFutureDate = project.AllowFutureDatesInTimesheets;
              _that.isTaskMandatory = project.MandateTasksInTimesheets;
            }
            // else
            // {

            //  this.getTimeSheetSettings()
            // }
          }
          // else if(res.data.ProjectList.length == 1)
          // {
          //   _that.projectSelected = _that.projectList[0].ProjectId
          // }
          else if (res.data.ProjectList.length == 0) {
            _that.projectSelected = 'Project unavailable'

            this.getTimeSheetSettings()
          }
          else {
            var projects = _that.projectList.filter(v => v.ProjectId == _that.timeSheetDetails.ProjectSelected).length > 0 ? _that.projectList.filter(v => v.ProjectId == _that.timeSheetDetails.ProjectSelected)[0] : null;

            if (projects != null && projects != '') {
              _that.timesheetAttachments = projects.IsClientAttachmentsRequired;
              _that.projectSelected = projects.ProjectId
              _that.timesheetCycle = projects.TimeSheetCycle;
              _that.MaximumRegulerTimesheetHours = projects.MaximumRegulerTimesheetHours
              _that.IsOverTimeApplicable = projects.IsOverTimeApplicable;
              // _that.IsSunday = projects.IsSunday;
              // _that.IsMonday = projects.IsMonday;
              // _that.IsTuesday = projects.IsTuesday;
              // _that.IsWednesday  = projects.IsWednesday;
              // _that.IsThursday  = projects.IsThursday;
              // _that.IsFriday  = projects.IsFriday;
              // _that.IsSaturday  = projects.IsSaturday;
              _that.IsAllowFutureDate = projects.AllowFutureDatesInTimesheets;
              _that.isTaskMandatory = projects.MandateTasksInTimesheets;
            }
            else {
              _that.projectSelected = _that.timesheetId != null && _that.timesheetId != '' ? 'Project unavailable' : ''

              this.getTimeSheetSettings()
            }


          }
          // else if(res.data.ProjectList.length == 0)
          // {
          //   setTimeout(() => {
          //     _that.$refs.dateTo.data.maxDate(moment().add(1,'months'))
          //     _that.$refs.dateFrom.data.maxDate(moment().add(1,'months'))
          //   }, 100)
          // }
          if (_that.projectSelected != null && _that.projectSelected != '') {
            _that.onProjectSelected(_that.projectSelected)
          }
          _that.getProjectOptionList()
          // _that.projectListOptions.data = __.map(_that.projectList, (t) => {
          //   let endClientName = t.EndClientName != null &&  t.EndClientName != null ? ' - ' + t.EndClientName : ''
          //   return { 'id': t.ProjectId, 'text': t.ProjectTitle + endClientName}
          // })
          _that.showProjectOptions = true
        }
        _that.$loading({}).close();
      })
    },
    getTimesheetDetails() {
      ajax.get(`TimeSheets/Detail/${this.timesheetId}?employeeId=${this.EmployeeId}`, {}, (res) => {
        if (res.data.State == true) {
          this.timeSheetDetails = res.data.TimeSheetDetailModel
          if (res.data.TimeSheetDetailModel.Attachments != undefined && res.data.TimeSheetDetailModel.Attachments != null) {
            this.Attachments = res.data.TimeSheetDetailModel.Attachments
          }
          if (res.data.TimeSheetDetailModel.ExpenseDetailModel.ExpenseModel != undefined && res.data.TimeSheetDetailModel.ExpenseDetailModel.ExpenseModel != null) {
            this.ExpenseModel = res.data.TimeSheetDetailModel.ExpenseDetailModel.ExpenseModel
            this.ExpenseStatus = res.data.TimeSheetDetailModel.ExpenseDetailModel.Status
            if (res.data.TimeSheetDetailModel.ExpenseDetailModel.ExpenseId != null) {
              this.ExpenseId = res.data.TimeSheetDetailModel.ExpenseDetailModel.ExpenseId
            }
          }
          if (res.data.TimeSheetDetailModel.TimesheetId != null) {
            this.TimesheetId = res.data.TimeSheetDetailModel.TimesheetId
          }
          this.DetailMode = !res.data.TimeSheetDetailModel.IsQuickMode
          this.Comments = res.data.TimeSheetDetailModel.Comments
          this.plannedActivities = res.data.TimeSheetDetailModel.PlannedActivities
          this.currentPeriodActivities = res.data.TimeSheetDetailModel.CurrentPeriodActivities

          this.assignDetails();
          this.getProjectList()
        }
      })
    },
    assignDetails() {
      this.IsWeekendChecked = this.timeSheetDetails.IsWeekendChecked
      this.projectSelected = this.timeSheetDetails.ProjectSelected == null || this.timeSheetDetails.ProjectSelected == '' ? 'Project unavailable' : this.timeSheetDetails.ProjectSelected;
      if (this.projectSelected == null || this.projectSelected == '') {
        this.timesheetCycle = ''
        this.MaximumRegulerTimesheetHours = 0
      }
      // this.TimesheetType = this.timeSheetDetails.SubmitType
      this.dateFrom = this.timeSheetDetails.FromDate;
      this.dateTo = this.timeSheetDetails.ToDate;
      var workSheets = this.timeSheetDetails.WorkSheets
      let arrayofDates = [...new Set(workSheets.map(item => item.Date))];
      for (var i = 0; i < arrayofDates.length; i++) {
        this.workingDaysList.push({
          Date: '',
          DayType: workSheets[i].DayType,
          totalTime: '',
          tasksList: [],
          show: true
        })
        var objectbyDate = workSheets.filter(v => v.Date == arrayofDates[i])
        this.workingDaysList[i].Date = arrayofDates[i]

        for (var j = 0; j < objectbyDate.length; j++) {

          var task = this.taskOptions.data.find(x=>x.id == objectbyDate[j].TaskId);
          var obj =
          {
            Date: objectbyDate[j].Date,
            Hours: objectbyDate[j].Hours.toString(),
            Minutes: objectbyDate[j].Minutes.toString(),
            ProjectId: objectbyDate[j].ProjectId,
            TaskId: objectbyDate[j].TaskId == null ? "" : objectbyDate[j].TaskId,
            TaskDescription: task != null ? task.description : '',
            IsTaskEdited: objectbyDate[j].IsTaskEdited,
            OverTimeHours: objectbyDate[j].OverTimeHours ? objectbyDate[j].OverTimeHours.toString() : '0',
            OverTimeMinutes: objectbyDate[j].OverTimeMinutes ? objectbyDate[j].OverTimeMinutes.toString() : '0',

          }
          this.workingDaysList[i].tasksList.push(obj)
        }
      }
    },
    showAddTaskButton(time, index) {
      var total = parseInt(time[0] + time[1])
      if (!this.IsOverTimeApplicable && this.MaximumRegulerTimesheetHours > 0) {
        if (total < this.MaximumRegulerTimesheetHours) {
          return true
        }
        else return false
      }
      else if (total < 24) {
        return true
      }
      else return false
    },
    getProjectsList() {
      ajax.get(`Project/Employee/ActiveOrPrevious/${this.EmployeeId}`, {}, (res) => {
        this.ProjectTitleList = res.data.ProjectList
        this.projectOptions.data = __.map(res.data.ProjectList, (t) => {
          return { 'id': t.Id, 'text': t.Name }
        })
      })
    },
    getTaskList() {
      this.showTaskSelect2 = false
      var taskempId = this.$route.query.from == 'employer-timesheets' ? this.selectedEmployeeID : this.EmployeeId;
      ajax.get(`Employee/${taskempId}/BasicTaskDetails?orgId=${this.loggedInUserObj.orgId}`, {}, (res) => {
        this.taskTitleList = res.data.TaskMetaData
        // this.isTaskMandatory = res.data.IsTimesheetDetailMode
        this.showPopover = res.data.IsQuickModePopup
        this.showTaskSelect2 = true
        this.taskOptions.data = __.map(res.data.TaskMetaData, (t) => {
          return { 'id': t.TaskId, 'text': t.Title,'description':t.Description,'createdByEmail':t.CreatedByEmail,'createdById':t.CreatedById }
        })
      })
    },
    HoursValidation() {
      let y = false;
      for (var i = 0; i < this.WorkSheets.length; i++) {
        y = y || this.totalHoursvalidation(this.WorkSheets[i], 2) || this.compareMaxHours(this.WorkSheets[i], 2)
      }
      return y;
    },
    // isWeekDays(item)
    // {
    //   var dt = new Date(item.Date);
    //   if(dt.getDay() == 0 || dt.getDay() == 6){
    //     return false
    //   }
    //   else{
    //     return true
    //   }
    // },
    isValid(val) {
      this.isSavedClicked = true;
      if (!this.DetailMode && this.TimesheetType != 'ExpensesOnly') {
        this.FormatWorkItemsForDetailMode();
      }
      if (this.WorkSheets != null && this.WorkSheets != "" && this.WorkSheets.length > 0 && this.$refs.timesheetExpenses != undefined && this.$refs.timesheetExpenses != null) {
        this.$refs.timesheetExpenses.saveExpenses();
      }
      this.validateAttachments();
      this.$v.dateFrom.$touch();
      this.$v.employeeSelected.$touch();
      this.$v.dateTo.$touch();
      if(this.isTaskMandatory){
        this.$v.plannedActivities.$touch();
      }
      if(!this.DetailMode && this.isTaskMandatory){
        this.$v.currentPeriodActivities.$touch();
      }
      // this.$v.WorkSheets.$touch();
      if (this.TimesheetType != 'ExpensesOnly') {
        this.$v.WorkSheets.$touch();
      }
      this.$v.projectSelected.$touch();
      let x = false
      let isPlannedValid = !this.$v.plannedActivities.$error;
      let isCurrentValid = !this.$v.currentPeriodActivities.$error;

      let isActivityValid = false;
      let QuickHoursvalidation = false;
      let hoursValidation = this.HoursValidation();
      if(this.TimesheetType != 'ExpensesOnly'){
      if (this.DetailMode) {
        isActivityValid = isPlannedValid;
      } else {
        isActivityValid = isPlannedValid && isCurrentValid;
      }
      if (!this.DetailMode) {
        QuickHoursvalidation = this.$refs.quicktimesheets.IsValid;
      }

      if (this.DetailMode) {
        for (var i = 0; i < this.WorkSheets.length; i++) {
          if (this.WorkSheets[i].IsWeekDay) {
            if ((!this.AllowTimeSheetSubmissionOnHolidays) && (this.WorkSheets[i].DayType == 'FederalHoliday' || this.WorkSheets[i].DayType == 'Holiday')) {
              x = false
            }
            else if ((!this.AllowTimeSheetSubmissionOnLeaves) && (this.WorkSheets[i].DayType == 'Leave')) {
              x = false
            }
            else {
              for (var j = 0; j < this.WorkSheets[i].tasksList.length; j++) {
                var y = false
                y = this.$v.WorkSheets.$each[i].tasksList.$each[j].Hours.$error || this.$v.WorkSheets.$each[i].tasksList.$each[j].Minutes.$error || this.$v.WorkSheets.$each[i].tasksList.$each[j].TaskId.$error
                x = x || y
              }
            }
          }
        }
      }
      if (!this.DetailMode) {
        for (var i = 0; i < this.WorkSheets.length; i++) {
          if (this.WorkSheets[i].IsWeekDay) {
            if ((!this.AllowTimeSheetSubmissionOnHolidays) && (this.WorkSheets[i].DayType == 'FederalHoliday' || this.WorkSheets[i].DayType == 'Holiday')) {
              x = false
            }
            else if ((!this.AllowTimeSheetSubmissionOnLeaves) && (this.WorkSheets[i].DayType == 'Leave')) {
              x = false
            }
            else {
              for (var j = 0; j < this.WorkSheets[i].tasksList.length; j++) {
                var y = false
                y = this.$v.WorkSheets.$each[i].tasksList.$each[j].Hours.$error || this.$v.WorkSheets.$each[i].tasksList.$each[j].Minutes.$error
                x = x || y
              }
            }
          }
        }
      }
    }
      if (this.TimesheetType == 'ExpensesOnly') {
        if (!x && this.$v.dateFrom.$error == false && this.$v.dateTo.$error == false && this.$v.projectSelected.$error == false && this.$v.employeeSelected.$error == false && this.isExpensesValid) {
          this.sendForApproval(val)
        }
      }
      else if (this.TimesheetType == 'TimesheetOnly') {
        if (!x && this.$v.dateFrom.$error == false && this.$v.dateTo.$error == false && this.$v.projectSelected.$error == false && this.$v.employeeSelected.$error == false && !this.isValidate && !hoursValidation && !QuickHoursvalidation && this.isCommentsValid == true && isActivityValid) {
          this.sendForApproval(val)
        }
      }
      else if (this.$refs.timesheetExpenses != undefined && this.$refs.timesheetExpenses != null) {
        var expenseModel = this.$refs.timesheetExpenses.formatTimesheetExpanseObjectToSave();
        var ExpenseErrormessage = false
        if (expenseModel == null || expenseModel == '') {
          ExpenseErrormessage = true
        }
        if (!x && this.$v.dateFrom.$error == false && this.$v.dateTo.$error == false && this.$v.projectSelected.$error == false && this.$v.employeeSelected.$error == false && !this.isValidate && this.isExpensesValid && !hoursValidation && !QuickHoursvalidation && this.isCommentsValid == true && isActivityValid) {
          this.sendForApproval(val)
        }
      }
      // if(!x && this.$v.dateFrom.$error == false && this.$v.dateTo.$error == false && this.$v.projectSelected.$error == false  && this.$v.employeeSelected.$error == false && !this.isValidate && this.isExpensesValid && !hoursValidation && !QuickHoursvalidation){
      //     this.sendForApproval(val)
      // }
      // else{
      // }
    },
    sendForApproval(val) {
      this.$loading({ 'loadingText': 'Loading...' })
      var workSheets = [];
      let selectedProject = this.projectSelected
      for (var i = 0; i < this.WorkSheets.length; i++) {
        for (var j = 0; j < this.WorkSheets[i].tasksList.length; j++) {
          if (selectedProject == 'Project unavailable') {
            selectedProject = ''
          }
          this.WorkSheets[i].tasksList[j].ProjectId = selectedProject
          workSheets.push(this.WorkSheets[i].tasksList[j])
        }
      }


      let expenseModel = ''
      if (this.TimesheetType != 'TimesheetOnly' && this.$refs.timesheetExpenses != undefined && this.$refs.timesheetExpenses != null) {
        expenseModel = this.$refs.timesheetExpenses.formatTimesheetExpanseObjectToSave();
      }
      else {
        expenseModel = ''
      }
      if (this.$route.query.from == 'employer-timesheets') {
        var SelectedEmpId = this.selectedEmployeeID
      }
      else {
        SelectedEmpId = this.EmployeeId
      }

      var expenseObject =
      {
        //TimeSheetId:this.timesheetId,
        ExpenseId: this.ExpenseId,
        EmployeeId: SelectedEmpId,
        ProjectId: selectedProject,
        ExpenseModel: expenseModel,
      }
      var Obj = {
        "Id": this.timesheetId,
        "EmployeeId": SelectedEmpId,
        "OrganizationId": this.OrganisationId,
        "FromDate": this.dateFrom,
        "ToDate": this.dateTo,
        "WorkSheets": workSheets,
        "Attachments": this.Attachments,
        "ProjectSelected": selectedProject,
        "ExpenseDetailModel": expenseObject,
        "IsQuickMode": !this.DetailMode,
        "IsQuickModePopup": this.showPopover,
        "IsWeekendChecked": this.IsWeekendChecked,
        "Type": this.TimesheetType == "TimesheetAndExpenses" ? "TimesheetExpense" : this.TimesheetType == "TimesheetOnly" ? "Timesheet" : "Expense",
        "PlannedActivities": this.plannedActivities,
        "CurrentPeriodActivities": this.currentPeriodActivities,
        "Comments": this.Comments,
        "TimesheetId": this.TimesheetId,
      }
      let endPoint;
      if (val == 'Save') {
        endPoint = "TimeSheets/Save"
      }
      else if (val == 'Add') {
        endPoint = "TimeSheets/AddOrEdit"
      }
      else {
        endPoint = "TimeSheets/SubmitTimesheets"
      }
      ajax.post(endPoint, Obj, (res) => {
        this.$loading({ 'loadingText': 'Loading...' })
        if (res.data.State == true) {
          if (this.$route.query.from == 'employer-timesheets') {
            if (val == 'Add' || val == 'Save') {
              this.$message({
                type: 'success',
                message: this.TimesheetType == "TimesheetAndExpenses" ? `${this.timesheetLabel} and Expense(s) saved successfully` : this.TimesheetType == "TimesheetOnly" ? `${this.timesheetLabel} saved successfully` : "Expense(s) saved successfully",
                // message: "Timesheet(s) saved successfully"
              });
              this.TimesheetCancel();
            }
            else if (val == 'submit') {
              if (this.taskExistForTimesheet()) {
                this.TimesheetId = res.data.TimeSheetId
                this.openEvalutionPopup = true;
                this.showProjectOptions = false;
                this.showEmployeeList = false;
                events.fire("hideExpenseOption", false);
              }
              else {
                this.$message({
                  type: 'success',
                  message: this.TimesheetType == "TimesheetAndExpenses" ? `${this.timesheetLabel} and Expense(s) approved successfully` : this.TimesheetType == "TimesheetOnly" ? `${this.timesheetLabel} approved successfully` : "Expense(s) approved successfully",
                  // message: "Timesheet(s) approved successfully"
                });
                this.TimesheetCancel();
              }
            }
          }
          else {
            if (val == 'Save') {
              this.$message({
                type: 'success',
                message: this.TimesheetType == "TimesheetAndExpenses" ? `${this.timesheetLabel} and Expense(s) saved successfully` : this.TimesheetType == "TimesheetOnly" ? `${this.timesheetLabel} saved successfully` : "Expense(s) saved successfully",
                // message: "Timesheet(s) saved successfully"
              });
            }
            else {
              this.$message({
                type: 'success',
                message: this.TimesheetType == "TimesheetAndExpenses" ? `${this.timesheetLabel} and Expense(s) sent for verification` : this.TimesheetType == "TimesheetOnly" ? `${this.timesheetLabel} sent for verification` : "Expense(s) sent for verification",
                //message: this.timesheetId != '' ? ResourceCore.Messages["Timesheet_Added"] : ResourceCore.Messages["Timesheet_Updated"]
              });
            }
            this.cancel('success')
          }
          this.$loading({}).close();
        } else if (res.data.State == false) {
          this.$loading({}).close();
          this.$message({
            type: 'error',
            message: res.data.Message
          })
        }
      })
    },
    cancel(p) {
      var routeName = this.$route.query.from
      var routerPush;
      if (routeName == 'evaluation') {
        this.$router.push({ name: "evaluation" });
      }
      else {
        this.$router.push({ name: "my-timesheets" });
      }
    },
    OnEvaluationRatingPopupClosed() {
      this.openEvaluationRating = false;
      this.openEvaluationReport = true;
    },
    OpenvaluationReport() {
      this.iframeURL = ''
      // this.selectedEventInfo = event;
      this.$loading({ 'loadingText': 'Loading...' })
      this.iframeURL = '';
      ajax.get(`TimeSheets/Report/${this.TimesheetId}?employeeId=${this.employeeSelected}`, {}, (res) => {
        if (res.data.State == true) {
          this.iframeURL = res.data.ReportUrl;//utils.getFilePreviewLink(res.data.ReportUrl)
          this.openEvaluationReport = true
        }
        this.$loading({}).close()
      })
    },
    OnOpenEvaluationRatingPopUp() {
      this.openEvaluationReport = false;
      this.openEvaluationRating = true;
    },
    taskExistForTimesheet() {
      let workSheets = [];

      for (var i = 0; i < this.WorkSheets.length; i++) {
        for (var j = 0; j < this.WorkSheets[i].tasksList.length; j++) {
          if (this.projectSelected == 'Project unavailable') {
            this.projectSelected = ''
          }
          this.WorkSheets[i].tasksList[j].ProjectId = this.projectSelected
          workSheets.push(this.WorkSheets[i].tasksList[j])
        }
      }

      let taskIdList = workSheets.map(item => item.TaskId).filter(item => item != '' && item != null && item != undefined)

      if (taskIdList.length > 0) {
        return true
      }
      else {
        return false
      }
    },
    onFromDateChange(e) {
      if (e.date != false) {
        setTimeout(() => {
          //this.$refs.dateTo.data.minDate(e.date)
          this.options4.minDate = moment(e.date).format('MM/DD/YYYY')
          this.keyValueUpdate++;
        }, 100)
        //this.updateToDatePicker(e.date);
      }
    },
    onDateChangeResetData() {
      for (var i = 0; i < this.WorkSheets.length; i++) {
        for (var j = 0; j < this.workingDaysList.length; j++) {
          if (moment(this.WorkSheets[i].Date).format('MM/DD/YYYY') == moment(this.workingDaysList[j].Date).format('MM/DD/YYYY')) {
            this.WorkSheets[i].Date = this.workingDaysList[j].Date
            this.WorkSheets[i].DayType = this.workingDaysList[j].DayType
            this.WorkSheets[i].totalTime = this.workingDaysList[j].totalTime
            this.WorkSheets[i].tasksList = this.workingDaysList[j].tasksList
          }
        }
      }
      if (!this.DetailMode) {
        this.FormatWorkItemsForQuickMode()
      }
      this.caliculateTotalTime();
    },
    getWorkSheets() {
      this.keyValueUpdate++
      this.$loading({ 'loadingText': 'Loading...' })
      var SelectedEmpId = '';
      if (this.$route.query.from == 'employer-timesheets') {
        SelectedEmpId = this.selectedEmployeeID
      }
      else {
        SelectedEmpId = this.EmployeeId
      }
      ajax.get(`TimeSheets/WorkingDays/${SelectedEmpId}/${this.OrganisationId}?fromDate=${this.dateFrom}&toDate=${this.dateTo}&timeSheetId=${this.timesheetId}`, {}, (res) => {
        if (res.data.State == true) {
          // this.directHoursEntered = ""
          if (this.WorkSheets.length > 0) {
            this.workingDaysList = []
            this.workingDaysList = this.WorkSheets
          }
          // this.IsCoincide = res.data.IsCoincide
          this.IsWorkingDaysAvailable = res.data.IsWorkingsDaysAvailable
          this.coinsideDateFrom = res.data.FromDate
          this.coinsideDateTo = res.data.ToDate
          // if(!this.IsCoincide)
          {
            this.WorkSheets = __.map(res.data.WorkingDaysList, (t) => {
              var isWeekday = this.IsWeekDay(t.Date);
              var tasksList = [{
                ProjectId: '',
                TaskId: '',
                Date: t.Date,
                Hours: '',
                Minutes: '',
                OverTimeHours: '',
                OverTimeMinutes: '',

              }];
              return { 'Date': t.Date, 'DayType': t.DayType, 'totalTime': '0 Hours', 'tasksList': tasksList, show: true, IsWeekDay: isWeekday }
            })
            this.onDateChangeResetData()
            this.$loading({}).close()
          }
        }
      })
    },
    callDateRange() {
      if (this.dateFrom != '' && this.dateTo != '') {
        this.getWorkSheets();
        this.getWorkHoursPerDay();
        if (this.IsDCAAComplianceToggleOn && this.submissionPreferenceType != '') {
          var date = moment().format('MM/DD/YYYY')
          var date1 = moment().format("MM/DD/YYYY")
          if (this.submissionPreferenceType == 'MustBeEnteredOnSameDay') {
            date = moment().format('MM/DD/YYYY')
          }
          else if (this.submissionPreferenceType == 'CanBeEnteredOnTheNextDay') {
            var startdate = moment();
            startdate = startdate.subtract(1, "days");
            date = startdate.format('MM/DD/YYYY')
          }
          else if (this.submissionPreferenceType == 'CanBeEnteredInWeeksTime') {
            let startDate = moment().startOf('week');
            let endDate = moment().endOf('week');
            date = startDate.format("MM/DD/YYYY")
            date1 = endDate.format("MM/DD/YYYY")
          }
          const range = moment(this.dateFrom, 'MM/DD/YYYY').twix(moment(this.dateTo, 'MM/DD/YYYY'), true);
        }
      }
    },
    getDayFormat(date) {
      var day = moment(date).format('dddd')
      return day
    },
    getDateFormat(date) {
      var date1 = moment(date).format('Do');
      var month = moment(date).format('MMM')
      return date1 + " " + month
    },
    removeTask(index, Index) {
      this.WorkSheets[index].tasksList.splice(Index, 1);
      this.select2close(index, Index, '', 0)
    },
    addTaskDetails(details, date, index) {

      details.push({
        ProjectId: '',
        TaskId: '',
        Date: date,
        Hours: '',
        Minutes: '',
        OverTimeHours: '',
        OverTimeMinutes: '',
      })
    },
    onAddAtachment() {
      this.showAttachmentDiv = true
      this.open()
    },
    getFileName(item) {
      var filename = utils.I9URL2FileName(item);
      var fileLength = filename.length
      if (fileLength > 33) {
        return filename.substring(0, 30) + "...";
      }
      else return filename
    },
    isFileType(item) {
      var filename = utils.I9URL2FileName(item);
      var fileExtention = filename.split('.').pop();
      var FileTypes = ["pdf", "png", "gif", "jpg", "jpeg"];
      return FileTypes.includes(fileExtention)
    },
    open() {
      setTimeout(() => {
        this.$refs.upload.uploadNew();
      }, 1000)
    },
    IsInvalidFile(error) {
      if (error != '') {
        this.$message({
          type: 'error',
          message: error
        });
      }
    },
    InProgress() {
      this.$loading({ 'loadingText': 'Loading...' })
      this.showAttachmentDiv = true
    },
    onuploadComplete(v) {
      for (var i = 0; i < v.length; i++) {
        if (v[i].response.Url != null)
          this.Attachments.push(v[i].response.Url);
        this.isErrorMessageDisabled = false
      }

      if (v[0].response.State == false && v[0].response.Message != null) {
        this.iCounter++
        this.isErrorMessageDisabled = true
        this.errorMessageFrmResponse = v[0].response.Message
      }
      this.showAttachmentDiv = false
      this.validateAttachments();
      this.$loading({}).close();
    },
    removeAttachments(index) {
      this.$alert2(`Are you sure you want to delete ?`, "Alert", {
        type: "confirm",
        yesButtonText: "Yes",
        noButtonText: "No",
        callback: (action) => {
          if (action === true) {
            this.Attachments.splice(index, 1)
          }
        }
      })
    },
    select2close(index, Index, type, val) {
      // on select 2 close..caliculating total hours for the date.
      this.calculateHours(index, Index, type, val);
    },
    caliculateTotalTime() { //total time for respective date for All worksheets
      for (var i = 0; i < this.WorkSheets.length; i++) {
        var selectedHours = 0
        var selectedMinutes = 0

        for (var j = 0; j < this.WorkSheets[i].tasksList.length; j++) {
          if (this.WorkSheets[i].tasksList[j].Hours != '' && this.WorkSheets[i].tasksList[j].Hours != null) {
            selectedHours = (parseInt(selectedHours) || 0) + (parseInt(this.WorkSheets[i].tasksList[j].Hours) || 0) + (parseInt(this.WorkSheets[i].tasksList[j].OverTimeHours) || 0);
          }
          if (this.WorkSheets[i].tasksList[j].Minutes != '' && this.WorkSheets[i].tasksList[j].Minutes != null) {
            selectedMinutes = (parseInt(selectedMinutes) || 0) + (parseInt(this.WorkSheets[i].tasksList[j].Minutes) || 0) + (parseInt(this.WorkSheets[i].tasksList[j].OverTimeMinutes) || 0);
          }
        }
        var hours = (selectedMinutes / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        this.Hours = 0;
        this.Minute = 0;
        var totalHours = parseInt(selectedHours) + parseInt(rhours)
        this.WorkSheets[i].totalTime = (parseInt(totalHours) || 0) + "h " + (parseInt(rminutes) || 0) + "m"
      }
    },
    calculateHours(index, Index, type, val) {
      //total time for respective date for one worksheets
      var selectedHours = 0
      var selectedMinutes = 0

      for (var j = 0; j < this.WorkSheets[index].tasksList.length; j++) {
        // if(this.WorkSheets[index].tasksList[j].Hours != '' && this.WorkSheets[index].tasksList[j].Hours != null){
        selectedHours = (parseInt(selectedHours) || 0) + (parseInt(this.WorkSheets[index].tasksList[j].Hours) || 0) + (parseInt(this.WorkSheets[index].tasksList[j].OverTimeHours) || 0);
        // }
        // if(this.WorkSheets[index].tasksList[j].Minutes != '' && this.WorkSheets[index].tasksList[j].Minutes != null){
        selectedMinutes = (parseInt(selectedMinutes) || 0) + (parseInt(this.WorkSheets[index].tasksList[j].Minutes) || 0) + (parseInt(this.WorkSheets[index].tasksList[j].OverTimeMinutes) || 0);
        //}
      }
      var hours = (selectedMinutes / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      this.Hours = 0;
      this.Minute = 0;
      var totalHours = parseInt(selectedHours) + parseInt(rhours)
      this.WorkSheets[index].totalTime = (parseInt(totalHours) || 0) + "h " + (parseInt(rminutes) || 0) + "m";
    },
    getWorkHoursPerDay() {
      var empId = this.EmployeeId;
      if (this.$route.query.from == 'employer-timesheets') {
        empId = this.selectedEmployeeID
      }
      ajax.get(`TimeSheets/WorkHoursPerDay?employeeId=${empId}&fromDate=${this.dateFrom}&toDate=${this.dateTo}&timeSheetId=${this.timesheetId}&projectId=${this.projectSelected}`, {}, (res) => {
        if (res.data.State == true) {
          this.PreviousWorkHours = res.data.hoursPerDay
        }
      })
    },
    getTimeSheetSettings() {
      this.$loading({ 'loadingText': 'Loading...' })
      ajax.get(`TimeSheets/Settings?orgId=${this.loggedInUserObj.orgId}`, {}, (res) => {
        if (res.data.State == true) {
          if (res.data.TimesheetSettings != null) {
            // this.IsAllowFutureDate = res.data.TimesheetSettings.AllowFutureDatesInTimesheets
            // this.isTaskMandatory  = res.data.TimesheetSettings.MandateTasksInTimesheets
            this.AllowTimeSheetSubmissionOnHolidays = res.data.TimesheetSettings.AllowTimeSheetSubmissionOnHolidays
            this.AllowTimeSheetSubmissionOnLeaves = res.data.TimesheetSettings.AllowTimeSheetSubmissionOnLeaves
            if (res.data.TimesheetSettings.TimesheetSubmitDays != null) {
              this.IsSunday = res.data.TimesheetSettings.TimesheetSubmitDays.IsSunday
              this.IsMonday = res.data.TimesheetSettings.TimesheetSubmitDays.IsMonday
              this.IsTuesday = res.data.TimesheetSettings.TimesheetSubmitDays.IsTuesday
              this.IsWednesday = res.data.TimesheetSettings.TimesheetSubmitDays.IsWednesday
              this.IsThursday = res.data.TimesheetSettings.TimesheetSubmitDays.IsThursday
              this.IsFriday = res.data.TimesheetSettings.TimesheetSubmitDays.IsFriday
              this.IsSaturday = res.data.TimesheetSettings.TimesheetSubmitDays.IsSaturday
            }
            if (res.data.TimesheetSettings.AllowFutureDatesInTimesheets != null && res.data.TimesheetSettings.AllowFutureDatesInTimesheets != undefined) {
              this.IsAllowFutureDate = res.data.TimesheetSettings.AllowFutureDatesInTimesheets.PreferenceApplied
            }
            if (res.data.TimesheetSettings.MandateTasksInTimesheets != null && res.data.TimesheetSettings.MandateTasksInTimesheets != undefined) {
              this.isTaskMandatory = res.data.TimesheetSettings.MandateTasksInTimesheets.PreferenceApplied
            }
            this.IsHybridMode = res.data.TimesheetSettings.IsHybridMode
            this.IsQuickOrDetailMode = res.data.TimesheetSettings.IsQuickOrDetailMode
            if(!this.IsQuickOrDetailMode && !this.IsHybridMode){
              this.DetailMode =false
            }

            this.IsDCAAComplianceToggleOn = res.data.TimesheetSettings.DCCACompliance
            this.submissionPreferenceType = res.data.TimesheetSettings.TimesheetSubmissionPrefference
          }
        }
        else {
          this.$message({
            type: 'error',
            message: res.data.Message
          })
        }
        this.$loading({}).close()
      })
    },
    guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
    },
    bindingReqObjectForAddTask(title, sheetIndex, taskIndex) {
      var list = []
      var taskListObj = {}
      var Obj = {}
      var empId = (this.$route.query.from == 'employer-timesheets') ? this.selectedEmployeeID : this.EmployeeId;
      var empList = []


      empList.push(empId)
      Obj = {
        "TaskId": this.guid(),
        "Title": title,
        "Description": '',
        "CreatedDate": moment().format('MM/DD/YYYY'),
        //"CreatedBy": this.CreatedByList[createdBySelectedIndex],
        "Hours": '',
        "Minutes": '',
        "EmployeeIdList": empList
      }
      list.push(Obj)

      taskListObj = {
        "Data": list
      }
      this.addTask(taskListObj)
      this.taskOptions.data.push({ 'id': Obj.TaskId, 'text': Obj.Title })
      this.WorkSheets[sheetIndex].tasksList[taskIndex].TaskId = Obj.TaskId

    },
    addTask(obj) {
      ajax.post(`/Task/Add`, obj, (res) => {
        if (res.data.State == true) {
          this.$message({
            type: 'success',
            message: "Task Added Successfully"
          });
          this.$loading({}).close();
        } else if (res.data.State == false) {
          this.$loading({}).close();
          this.$message({
            type: 'error',
            message: res.data.Message
          });
        }
      });
    },
    getselectedEmployeeData() {
      this.employmentStartDate = ''
      let arr = this.$refs.employeeListRef.getSelect2Data()
      this.employmentStartDate = arr && arr[0].EmploymentStartDate ? moment(arr[0].EmploymentStartDate).format('MM/DD/YYYY') : ''
    },
    fromDateValidation(val) {
      var project = [];
      if (this.projectList.length > 0) {
        project = this.projectList.filter(v => v.ProjectId == this.projectSelected)[0]
        if (project != "" && project != null) {
          var projectStartDate = moment(project.ProjectStartDate);
          var fromMinDate;
          if(this.employmentStartDate) {
            var employmentStartDate = moment(this.employmentStartDate)
            fromMinDate = employmentStartDate.isBefore(projectStartDate) ? projectStartDate : employmentStartDate
          }
          else {
            fromMinDate = projectStartDate
          }
          setTimeout(() => {
            if((!this.IsAllowFutureDate && this.timesheetCycle === 'Custom' )){
              var minDt = moment(this.PreviousDate).format('MM/DD/YYYY');
              this.$refs.dateFrom.data.minDate(minDt)
            }
            else if ((this.IsAllowFutureDate) && val != "dateTo") {
            this.$refs.dateFrom.data.minDate(fromMinDate.format('MM/DD/YYYY'))
            }
          }, 100)
        }
        else {
            setTimeout(() => {
              this.employmentStartDate ? this.$refs.dateFrom.data.minDate(moment(this.employmentStartDate).format('MM/DD/YYYY')) : ''
            }, 100)
          }
      }
      else {
          setTimeout(() => {
            this.employmentStartDate ? this.$refs.dateFrom.data.minDate(moment(this.employmentStartDate).format('MM/DD/YYYY')) : ''
          }, 100)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.Expense_popOver {
  z-index: 3;
  background: #2c88e0;
  box-shadow: 1px 1px 1px 1px #8888;
  margin-top: 5px;
  width: 21%;
  top: -26px !important;
  right: -26%;
  height: 123px;
  position: absolute;
  width: 23%
}

.Expense_popOver::after {
  content: "";
  position: absolute;
  top: 123px;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #2c88e0 transparent transparent transparent;
}

.btn_gotit {
  margin-top: 10px;
  background-color: transparent;
  color: white;
  border-color: white;
  font-weight: 600;
}

.btn_gotit:hover {
  margin-top: 10px;
  background-color: transparent;
  color: white;
  border-color: white;
  font-weight: 600;
}

.toggle-span {
  display: inline-block;
  background: #fff;
  border: 2px solid #DFDFDF;
  border-radius: 5px;
  font-weight: 600;
  float: left;

  .toggle-btn {
    border: 0;
    color: white;
    height: 28px;
    width: 70px;
  }

  .btn-toggle-selected {
    color: white;
    background-color: #143361;
    border-radius: 5px;
    margin: 2px;
  }

  .btn-toggle-un-selected {
    background-color: white;
    color: rgb(133, 149, 166);
  }
}

.add-timesheets {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.validation-star {
  color: #F31D1D;
}

.duration {
  width: 0px;
  font-size: 11px;
  font-weight: 600;
  color: #464444;
  margin-top: 1px;
  padding-right: 27px !important;
  height: 28px;
  display: inline-block;
  float: left;
}

.select2_style {
  width: 55px;
  display: inline-block;
}

.holiday {
  color: #333333;
  text-align: center;
  font-weight: 600;
  font-style: italic;
}

.attachments_view {
  padding: 0 15px;

  p {
    font-weight: 600;
  }

  .form-group {
    margin-left: -16px;
    margin-top: 15px;

    label {
      font-weight: 600;
      font-size: 11px;
    }
  }

  .attachments-view {
    margin-bottom: 5px;
    //color:#4A90E2;
    margin-left: 0px;
    border: 1px solid #4A90E2 !important;
    background: #e6eff9 !important;
    padding: 5px 10px;
    display: inline-block;
    border-radius: 30px;
    font-weight: bold;
    float: left;
    margin-right: 2%;
  }

  .cross-mark {
    font-size: 15px;
    padding: 0px 5px;
    border-radius: 100%;
    cursor: pointer;
  }

  .cross-mark:hover {
    background: #c2c2c2;
    padding: 0px 5px;
    border-radius: 100%;
    text-decoration: none !important;
  }

  .cursorCls {
    cursor: not-allowed !important;
  }

  .hideShow {
    pointer-events: none !important;
  }
}

.disabled-day {
  background: #FDF2F3;
  cursor: default;
  border: 0;
  padding: 15px;
  font-weight: bold;
  font-size: 12px;
  cursor: not-allowed;
}
.descriptn{
      display: block;
      width: 100%;
      height: 80px;
      border-color: #ddd;
      border-radius: 5px;
      padding: 10px;
      resize: none;
      margin-top: 10px;
    }
    .disable_textArea{
        margin-top: 10px;
        width: 100%;
        height: 80px;
        padding: 10px;
        resize: none;
        cursor: not-allowed;
        background-color: #eee !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/AddTimesheets.vue